{
  "updateGate": {
    "required": {
      "title": "التحديث مطلوب",
      "body": "هذه النسخة من تشكيلة لم تعد مدعومة. حدّث إلى أحدث نسخة عشان تكمّل اللعب."
    },
    "available": {
      "title": "تحديث جديد متاح ✨",
      "body": "في نسخة جديدة من تشكيلة جاهزة. حدّث دلوقتي عشان تجيب آخر المزايا والإصلاحات."
    },
    "ota": {
      "title": "تحديث جاهز ✨",
      "body": "اتنزّل تحديث جديد. أعِد التحميل دلوقتي عشان يتفعّل."
    },
    "cta": "تحديث",
    "opening": "بيفتح Play…",
    "reloadCta": "إعادة تحميل",
    "reloading": "جارٍ إعادة التحميل…",
    "later": "بعدين"
  },
  "common": {
    "appName": "تشكيلة",
    "retry": "حاول مجددًا",
    "cancel": "إلغاء",
    "save": "حفظ",
    "done": "تم",
    "close": "إغلاق",
    "back": "رجوع",
    "gotIt": "تمام",
    "howToPlay": "إزاي تلعب",
    "share": "مشاركة",
    "viaApp": "عبر تشكيلة",
    "confirm": "تأكيد",
    "delete": "حذف",
    "loading": "جارٍ التحميل…",
    "seeAll": "عرض الكل",
    "today": "اليوم",
    "yesterday": "أمس",
    "tomorrow": "غدًا",
    "live": "مباشر",
    "upcoming": "قادمة",
    "finished": "انتهت",
    "ft": "انتهت",
    "postponed": "مؤجلة",
    "pts": "نقطة",
    "min": "د",
    "errorTitle": "حدث خطأ ما",
    "errorBody": "تعذّر التحميل الآن. تحقق من اتصالك وحاول مجددًا.",
    "emptyTitle": "لا يوجد شيء هنا بعد",
    "offlineNote": "يبدو أنك غير متصل بالإنترنت.",
    "notConfiguredTitle": "الخادم غير متصل",
    "notConfiguredBody": "أضف رابط Supabase والمفتاح العام إلى ملف ‎.env ثم أعد تشغيل التطبيق. راجع README → الإعداد.",
    "signInRequiredTitle": "سجّل الدخول للمتابعة",
    "signInRequiredBody": "أنشئ حسابًا مجانيًا لبناء تشكيلتك والانضمام إلى الدوريات.",
    "comingSoon": "قريبًا"
  },
  "tabs": {
    "matches": "المباريات",
    "club": "النادي",
    "fantasy": "فانتازي",
    "games": "ألعاب",
    "leaderboard": "الترتيب",
    "predictions": "التوقعات",
    "leagues": "الدوريات",
    "search": "بحث",
    "profile": "حسابي"
  },
  "games": {
    "title": "الألعاب",
    "bracketPredictorTitle": "متوقّع كأس العالم",
    "bracketPredictorBody": "توقّع المجموعات وكل أدوار الإقصاء، واطلع في الترتيب.",
    "leaderboardsTitle": "الترتيبات",
    "leaderboardsBody": "شوف مين الأول في التوقعات والفانتازي.",
    "accaTitle": "كارت اليوم",
    "accaBody": "اعمل توقّع مجمّع من ماتشات اليوم. كل اختياراتك لازم تظبط عشان الجاكبوت.",
    "scorePredictTitle": "متوقّع النتيجة",
    "scorePredictBody": "توقّع نتيجة الماتشات الجاية بالظبط - صيبها وخد أعلى نقاط.",
    "sportsTitle": "رياضات وإلكترونية",
    "sportsBody": "تنس وCS:GO ودارتس وهوكي وباسكت لايف",
    "totrTitle": "تشكيلة الجولة",
    "totrBody": "أحسن 11 لاعب في الجولة الأخيرة بالنقاط.",
    "survivorTitle": "الناجي",
    "survivorBody": "راهن على منتخب يكسب كل جولة. تخسر مرة تطلع برّه، وممنوع تكرّر نفس المنتخب.",
    "challengesTitle": "التحديات اليومية",
    "challengesBody": "أسئلة سريعة عن الماتشات كل جولة. جاوب قبل ما الماتش يبدأ عشان نقط زيادة.",
    "qualificationTitle": "مين هيتأهّل؟",
    "qualificationBody": "اختار متصدّر كل مجموعة واكسب كوينز عن كل توقّع صح.",
    "goldenBootTitle": "الحذاء الذهبي",
    "goldenBootBody": "اختار هدّاف البطولة وتابع السباق.",
    "friendLeaguesTitle": "دوريات الأصحاب",
    "friendLeaguesBody": "اعمل دوري خاص أو تحدي 1 ضد 1 ونافس أصحابك في كل الألعاب.",
    "bracketLiveTitle": "شجرة الأدوار لايف",
    "bracketLiveBody": "تابع أدوار خروج المغلوب بتتملي لايف وشوف توقّعك ماشي إزاي.",
    "prizeDrawTitle": "السحب على الجوايز",
    "prizeDrawBody": "اصرف الكوينز اللي بتكسبها على تذاكر - واكسب جايزة الأسبوع.",
    "coinsBoardTitle": "ترتيب الكوينز",
    "coinsBoardBody": "شوف أغنى اللاعبين الموسم ده وترتيبك فين.",
    "emptyTitle": "ألعاب أكتر قريّب",
    "emptyBody": "ألعاب وتحديات جديدة هتنزل هنا.",
    "albumTitle": "ألبوم الاستيكرز",
    "albumBody": "اجمع كل نجوم كأس العالم. افتح باكت مجاني كل يوم واملا ألبومك.",
    "wcHeroKicker": "مسابقة البطولة",
    "wcHeroTitle": "توقّع كأس العالم 🏆",
    "wcHeroSubtitle": "توقّع كل مجموعة وكل أدوار الإقصاء، وبعدين اختار بطلك.",
    "wcHeroPrize": "أحسن ١٠ يكسبوا كوينز، ٥٠٠ للأول",
    "wcHeroCta": "العب دلوقتي"
  },
  "wc": {
    "out": "خرج",
    "knockedOut": "خرج من البطولة",
    "fantasyEliminatedWarning": "عندك {{count}} لاعيبة من منتخبات خرجت من البطولة، مش هيجيبوا نقط. يفضل تطلّعهم بترانسفير.",
    "hideEliminated": "إخفاء اللي خرجوا"
  },
  "album": {
    "title": "ألبوم الاستيكرز",
    "intro": "اجمع استيكر لكل لاعب في منتخبات دور الـ32. افتح باكت مجاني كل يوم، أو اصرف كوينز عشان أكتر.",
    "starsTitle": "نجوم البطولة",
    "openDaily": "افتح باكت اليوم",
    "openDailyFree": "مجاني النهاردة",
    "openDailyDone": "تعالى بكرة",
    "openCoins": "افتح باكت",
    "opening": "بيفتح…",
    "packCost": "{{coins}} كوينز",
    "progressOverall": "{{owned}}/{{total}}",
    "collected": "اتجمعوا",
    "completePercent": "اكتمل {{percent}}%",
    "signIn": "سجّل دخول عشان تبدأ تجميعك.",
    "newSticker": "جديد!",
    "duplicate": "مكرّر",
    "dupeCount": "×{{count}}",
    "revealTitle": "الاستيكرز بتاعتك",
    "revealNew": "{{count}} جديد",
    "revealNone": "كلهم مكرّرين المرّة دي - بس العدد بيزيد!",
    "tapToClose": "دوس عشان تكمّل",
    "missing": "لسه ماتجمعش",
    "teamProgress": "{{owned}}/{{total}}",
    "emptyTitle": "مفيش استيكرز لسه",
    "emptyBody": "الألبوم بيتملي أول ما تشكيلات كأس العالم تتزامن.",
    "completeTitle": "الألبوم كمل!",
    "completeBody": "جمعت كل استيكرز كأس العالم. أسطوري."
  },
  "challengeFriend": {
    "title": "تحدّى صاحبك",
    "tag": "1 ضد 1",
    "subtitle": "اعمل تحدّي 1v1 وابعت اللينك.",
    "duelName": "تحدّي {{name}}",
    "duelFallback": "تحدّي 1 ضد 1"
  },
  "widgets": {
    "title": "الويدجتس",
    "intro": "ويدجتس زجاجية حيّة لشاشتك الرئيسية. عاينها هنا، وبعدين أضفها من شاشتك.",
    "free": "مجاني",
    "matchName": "الماتش",
    "matchDesc": "نتيجة لايف، آخر مسجّل، المباريات الجاية وترتيب المجموعة.",
    "fantasyName": "الفانتازي",
    "fantasyDesc": "نقاط جولتك، ترتيبك، الكابتن وأحسن اللاعبين.",
    "spinName": "سبين بوست",
    "spinDesc": "حالة السبين بوست اليومي والعدّ التنازلي.",
    "previewAndroidOnly": "معاينة الويدجتس الحيّة بتظهر على أندرويد.",
    "homeTitle": "إضافة للشاشة الرئيسية",
    "homeStep1": "اضغط مطوّلاً على مكان فاضي في الشاشة الرئيسية.",
    "homeStep2": "اختار ويدجتس، وبعدين دوّر على تشكيلة.",
    "homeStep3": "اسحب ويدجت الماتشات في المكان اللي عايزه.",
    "lockTitle": "إضافة لشاشة القفل",
    "lockStep1": "افتح إعدادات شاشة القفل في تليفونك، وبعدين ويدجتس.",
    "lockStep2": "أضف ويدجت تشكيلة.",
    "lockNote": "ويدجتس شاشة القفل محتاجة أندرويد 16 أو One UI 8 أو أحدث. على التليفونات الأقدم النتايج لايف بتوصلك في الإشعارات."
  },
  "widgetStyles": {
    "title": "ستايل الويدجت",
    "subtitle": "اختار شكل ويدجت الشاشة الرئيسية. بيتحدّث على طول.",
    "gradientName": "متدرّج",
    "gradientDesc": "تدرّج نيلي زجاجي بحافة سماوية. الشكل الكلاسيكي.",
    "darkName": "غامق",
    "darkDesc": "كارت غامق فخم وصلب. نظيف وتباين عالي.",
    "glassName": "زجاجي",
    "glassDesc": "زجاج شفّاف، خلفية شاشتك بتبان من وراه.",
    "minimalName": "بسيط",
    "minimalDesc": "بلاطة أفتح بلمسات هادية ومتحفّظة.",
    "accentTitle": "لون التمييز",
    "accentSubtitle": "بيغيّر لون الحافة وشارة المباشر والإبرازات.",
    "accent_cyan": "سماوي",
    "accent_violet": "بنفسجي",
    "accent_emerald": "زمرّدي",
    "accent_amber": "كهرماني",
    "accent_rose": "وردي",
    "layoutTitle": "التخطيط",
    "layoutSubtitle": "ابدأ بمباراة واحدة أو بقائمة المباريات القادمة.",
    "layoutAuto": "كارت المباراة",
    "layoutUpcoming": "المباريات القادمة",
    "favoriteFirstTitle": "اعرض فريقي أولاً",
    "favoriteFirstDesc": "بيرفع فريق بتتابعه لأعلى القائمة ويبرزه."
  },
  "store": {
    "title": "متجر الكوينز",
    "balance": "كوينز",
    "framesSection": "إطارات الأفاتار",
    "equip": "فعّل",
    "equipped": "مفعّل",
    "removed": "اتشال الإطار",
    "bought": "اشتريته! فعّله من هنا.",
    "equipDone": "اتفعّل الإطار",
    "hint": "اصرف الكوينز بتاعك على إطارات بتظهر حوالين صورة بروفايلك.",
    "balanceLabel": "رصيدك",
    "featured": "مميّز",
    "ownedTag": "مملوك",
    "earnTitle": "محتاج كوينز أكتر؟",
    "earnHint": "اتفرّج على إعلان قصير أو خلّص مهامك اليومية عشان ترصّد كوينز.",
    "frames": {
      "bronze": "برونزي",
      "silver": "فضّي",
      "gold": "دهبي",
      "volt": "توهّج فولت",
      "gradient": "أورورا",
      "champion": "البطل"
    }
  },
  "qualification": {
    "title": "التأهّل",
    "intro": "لو كل مجموعة خلصت دلوقتي، دول اللي هيوصلوا دور الـ32.",
    "pts": "{{pts}} نقطة",
    "status": {
      "qualified": "متأهّل",
      "third_in": "أحسن ثالث",
      "third_out": "ع الحافة",
      "out": "خارج"
    },
    "emptyTitle": "مفيش ترتيب لسه",
    "emptyBody": "التوقّع بيظهر أول ما ماتشات المجموعات تبدأ.",
    "predictIntro": "دوس على الفريق اللي شايفه هيتصدّر كل مجموعة. +12 كوين عن كل متصدّر تصيبه.",
    "save": "احفظ توقّعاتي",
    "saved": "اتحفظت التوقّعات - بالتوفيق!",
    "signIn": "سجّل دخولك عشان تحفظ توقّعاتك.",
    "progress": "اخترت {{picked}} من {{total}} مجموعة",
    "scoredLine": "النهائي: {{pts}} نقطة",
    "yourWinner": "اختيارك",
    "tabThrough": "المتأهّلون",
    "tabPredict": "اختار المتصدّرين",
    "throughIntro": "لو كل مجموعة خلصت دلوقتي، الـ32 فريق دول هيوصلوا دور الـ32.",
    "qualifiedTitle": "متأهّلون",
    "bestThirdTitle": "أحسن أصحاب مركز ثالث",
    "qualified": "متأهّل",
    "bestThird": "أحسن ثالث",
    "groupShort": "مجموعة {{group}}",
    "rankShort": "المركز {{rank}}",
    "throughEmptyTitle": "محدش متأهّل لسه",
    "throughEmptyBody": "الفرق المتأهّلة بتظهر أول ما ماتشات المجموعات تبدأ."
  },
  "scorePredict": {
    "title": "متوقّع النتيجة",
    "intro": "توقّع النتيجة النهائية للماتشات الجاية بالظبط. النتيجة بالظبط = 5 نقاط، النتيجة الصح = نقطتين، وكمان كوينز.",
    "totalPts": "إجمالي النقاط",
    "signIn": "سجّل دخولك عشان تحفظ توقّعاتك.",
    "upcoming": "القادمة",
    "results": "نتايجك",
    "save": "احفظ التوقّع",
    "saved": "اتحفظ التوقّع - بالتوفيق!",
    "locked": "اتحفظ",
    "yourPick": "توقّعك: {{score}}",
    "pts": "نقطة",
    "leaderboard": "الترتيب",
    "exactsLine": "{{exacts}} بالظبط",
    "noFixturesTitle": "مفيش ماتشات للتوقّع",
    "noFixturesBody": "تعالى تاني لما الماتشات الجاية تتحدّد.",
    "doubleCta": "ضاعفها - شوف إعلان قصير",
    "doubled": "اتضاعفت!",
    "doubledToast": "اتضاعفت! +{{coins}} كوين"
  },
  "shareCard": {
    "shareImage": "شيرها كصورة",
    "exactHit": "النتيجة بالظبط!",
    "points": "+{{pts}} نقطة",
    "yourPick": "توقّعك",
    "shareLineExact": "ظبطت النتيجة بالظبط!",
    "shareLinePoints": "جبت +{{pts}} نقطة",
    "shareLineYourPick": "توقّعي: {{score}}"
  },
  "brag": {
    "action": "افتخر",
    "kicker": "موسمي",
    "subtitle": "توقّعات تشكيلة",
    "aPlayer": "لاعب في تشكيلة",
    "rankLabel": "الترتيب العالمي",
    "points": "نقاط",
    "correct": "صحيحة",
    "streak": "سلسلة",
    "cta": "حمّل تشكيلة",
    "shareLineRank": "أنا #{{rank}} على تشكيلة بـ {{points}} نقطة 🎯",
    "shareLineStreak": "أنا #{{rank}} على تشكيلة · سلسلة {{streak}} يوم 🔥"
  },
  "bracketShare": {
    "action": "شارك توقّعي",
    "kicker": "كأس العالم بتاعي",
    "championLabel": "بطلي",
    "noChampion": "لسه مفيش بطل",
    "points": "نقاط",
    "rank": "الترتيب",
    "cta": "حمّل تشكيلة",
    "shareLineRank": "بطل كأس العالم بتاعي {{champion}}، وأنا #{{rank}} على تشكيلة 🏆",
    "shareLineChampion": "أنا مراهن إن {{champion}} هياخد كأس العالم على تشكيلة 🏆"
  },
  "winCelebration": {
    "title": "توقّعت صح! 🎯",
    "matchLine": "{{home}} {{score}} {{away}}",
    "wonPoints": "توقّعك صحّ وكسبت {{points}} نقطة",
    "wonCoins": "توقّعك صحّ وكسبت {{coins}} كوينز",
    "wonPlain": "توقّعك صحّ",
    "share": "شارك",
    "done": "تمام",
    "shareLinePoints": "توقّعت {{match}} صح على تشكيلة وكسبت {{points}} نقطة 🎯",
    "shareLineCoins": "توقّعت {{match}} صح على تشكيلة وكسبت {{coins}} كوينز 🪙",
    "shareLinePlain": "توقّعت صح على تشكيلة 🎯"
  },
  "livePredict": {
    "title": "مين هيجيب الجول الجاي؟",
    "subtitle": "توقّع الجول الجاي لايف",
    "vs": "ولا",
    "community": "{{count}} بيلعبوا",
    "beFirst": "كن أول واحد يتوقّع",
    "yourPickIn": "توقّعك اتسجّل - بالتوفيق!",
    "signIn": "سجّل دخولك عشان تلعب التوقّعات اللايف.",
    "locked": "اتسجّل توقّعك!"
  },
  "predictWin": {
    "title": "🎯 توقّع واكسب كوينز",
    "subtitle": "راهن بالكوينز على النتيجة",
    "forFunTag": "كوينز للتسلية بس",
    "draw": "تعادل",
    "stakeLabel": "رهانك",
    "balance": "{{coins}} كوينز",
    "potentialPayout": "الربح المتوقّع",
    "placePick": "ثبّت التوقّع",
    "placing": "جاري التثبيت…",
    "placed": "اتثبّت توقّعك - بالتوفيق!",
    "choosePrompt": "اختار نتيجة الأول.",
    "signIn": "سجّل دخولك عشان تلعب.",
    "yourPick": "توقّعك: {{side}}",
    "stakedToWin": "رهنت {{stake}} · هتكسب {{toWin}}",
    "statusPending": "في انتظار النتيجة…",
    "statusWon": "كسبت +{{payout}} كوينز",
    "statusLost": "مكسبتش المرة دي.",
    "statusVoid": "اتردّ رهانك."
  },
  "predictWeekly": {
    "title": "تحديات الأسبوع",
    "subtitle": "توقّع واكسب · خلّصت {{done}}/{{total}} الأسبوع ده",
    "earned": "+{{coins}}",
    "progressRow": "{{done}}/{{target}}",
    "doneRow": "خلّصت · +{{coins}} كوينز",
    "goals": {
      "place_5": {
        "title": "ثبّت {{target}} توقّعات"
      },
      "correct_3": {
        "title": "صحّح {{target}} نتايج"
      },
      "underdog_1": {
        "title": "اكسب على فريق ضعيف (3×+)"
      }
    },
    "board": {
      "title": "ترتيب الكوينز",
      "intro": "الترتيب حسب إجمالي الكوينز الموسم ده.",
      "you": "إنت",
      "yourRank": "إنت رقم #{{rank}} الموسم ده",
      "emptyTitle": "مفيش كوينز في الترتيب لسه",
      "emptyBody": "العب أي لعبة عشان تكسب كوينز وتطلع في الترتيب."
    }
  },
  "matchReminder": {
    "cta": "فكّرني",
    "on": "التذكير مفعّل",
    "set": "هنفكّرك قبل الماتش بـ 10 دقايق",
    "removed": "اتشال التذكير",
    "failed": "مش قادرين نظبط التذكير",
    "notifTitle": "⏰ {{home}} ضد {{away}}",
    "notifBody": "الماتش هيبدأ خلال 10 دقايق"
  },
  "today": {
    "firstPredict": {
      "title": "اعمل أول توقّع ليك 🎯",
      "body": "خلصت التجهيز. توقّع نتيجة ماتش النهارده عشان تبدأ تكسب كوينز وتطلع في الترتيب.",
      "cta": "توقّع ماتش",
      "later": "بعدين يمكن"
    },
    "title": "النهارده",
    "coins": "كوينز",
    "streak": "يوم ستريك",
    "matches": "ماتشات النهارده",
    "liveCount": "{{count}} لايف",
    "noMatchesTitle": "مفيش ماتشات النهارده",
    "noMatchesBody": "تعالى بكرة للجولة الجاية.",
    "forYou": "ليك إنت",
    "picksTitle": "توقّعات الماتشات",
    "signInPicks": "سجّل دخولك عشان تتوقّع ماتشات النهارده.",
    "picksNone": "توقّع ماتشات النهارده واكسب كوينز.",
    "picksNoMatches": "مفيش ماتشات للتوقّع دلوقتي.",
    "picksSummary": "اخترت {{made}} - فاضل {{pending}} يتحسبوا",
    "missionsTitle": "المهام اليومية",
    "signInMissions": "سجّل دخولك عشان تبدأ مهامك اليومية.",
    "missionsSummary": "{{done}}/{{total}} خلصوا - فاضل {{coins}} كوين تكسبهم",
    "missionsAllDone": "خلّصت كل الـ{{total}} مهمة. جامد!",
    "sportsTitle": "الرياضات والإلكترونية",
    "sportsBody": "تنس، CS:GO، دارتس، هوكي وكرة سلة مباشرة.",
    "newsTitle": "أخبار كأس العالم",
    "newsBody": "آخر أخبار البطولة والملخّصات والعناوين.",
    "wcGroupsTitle": "المجموعات والأدوار",
    "wcGroupsBody": "جداول المجموعات كاملة وتصنيف فيفا وجدول الأدوار الإقصائية.",
    "checklist": "مهام النهارده",
    "progressDone": "خلّصت {{done}}/{{total}} النهارده",
    "allDoneTitle": "خلّصت كل حاجة النهارده!",
    "allDoneBody": "خلّصت كل المهام اليومية. تعالى بكرة عشان تحافظ على الستريك.",
    "streakFlame": "ستريك {{count}} يوم",
    "streakNone": "ابدأ الستريك بتاعك النهارده",
    "go": "يلا",
    "claim": "استلم",
    "open": "افتح",
    "done": "تمام",
    "checkinTitle": "تسجيل الدخول اليومي",
    "checkinClaim": "استلم مكافأة النهارده وكبّر الستريك بتاعك.",
    "checkinDone": "سجّلت دخولك - ستريك {{count}} يوم",
    "predictTitle": "توقّع ماتشات النهارده",
    "predictProgress": "توقّعت {{made}}/{{total}}",
    "predictAllDone": "توقّعت كل الـ{{total}} ماتش",
    "predictNoneToday": "مفيش ماتشات تتوقّعها النهارده.",
    "packTitle": "افتح الباكت المجاني اليومي",
    "packAvailable": "فيه باكت ستيكرز مجاني مستنيك.",
    "packDone": "فتحت باكت النهارده - تعالى بكرة",
    "accaTitle": "كارت التوقّعات بتاع اليوم",
    "accaProgress": "اخترت {{picked}}/{{total}} توقّعات",
    "accaAllDone": "قفلت كل الـ{{total}} توقّعات",
    "accaNoneToday": "مفيش كارت متاح النهارده.",
    "potmTitle": "صوّت لأحسن لاعب في الماتش",
    "potmBody": "قول رأيك في أحسن لاعب النهارده.",
    "potmNone": "مفيش ماتش لايف أو خلص عشان تصوّت فيه لسه.",
    "hubCardTitle": "النهارده",
    "hubCardBody": "مهامك اليومية والستريك والماتشات في مكان واحد."
  },
  "discover": {
    "title": "اكتشف",
    "newsSub": "أخبار وملخّصات وعناوين",
    "groupsSub": "جداول المجموعات والأدوار",
    "sportsSub": "تنس وCS:GO وغيرها مباشرة",
    "historySub": "نهائيات وأبطال زمان"
  },
  "wcGroups": {
    "title": "مجموعات كأس العالم",
    "tabGroups": "المجموعات",
    "tabBracket": "الأدوار الإقصائية",
    "groupsSubtitle": "جداول المجموعات مباشرة مع تصنيف فيفا والأداء الأخير والتأهّل.",
    "bracketSubtitle": "الطريق إلى النهائي، دورًا بدور.",
    "groupNum": "المجموعة {{num}}",
    "played": "ل",
    "won": "ف",
    "drawn": "ت",
    "lost": "خ",
    "gf": "له",
    "ga": "عليه"
  },
  "history": {
    "title": "تاريخ كأس العالم",
    "subtitle": "كل نهائي وبطله.",
    "versus": "ضد",
    "final": "النهائي",
    "finalists": "المتأهلان للنهائي",
    "showAll": "عرض الكل ({{count}})",
    "showLess": "عرض أقل",
    "emptyTitle": "التاريخ مش متاح لسه",
    "emptyBody": "نهائيات كأس العالم القديمة هتظهر هنا بعد ما المزامنة تشتغل."
  },
  "sports": {
    "title": "الرياضات والإلكترونية",
    "tennis": "تنس",
    "csgo": "CS:GO",
    "darts": "دارتس",
    "hockey": "هوكي",
    "basketball": "كرة السلة",
    "americanFootball": "فوتبول أمريكي",
    "baseball": "البيسبول",
    "volleyball": "الكرة الطائرة",
    "handball": "كرة اليد",
    "rugby": "الرغبي",
    "vs": "ضد",
    "mode": {
      "live": "مباشر",
      "upcoming": "قادمة",
      "finished": "منتهية"
    },
    "empty": {
      "live": "مفيش {{sport}} مباشر دلوقتي",
      "upcoming": "مفيش {{sport}} قادمة",
      "finished": "مفيش نتائج {{sport}} حديثة"
    },
    "emptyBody": "بعض الرياضات بتهدأ بين المواسم. جرّب رياضة تانية أو ارجع بعد شوية.",
    "seeUpcoming": "شوف القادمة",
    "footnote": "مدعوم من Bzzoiro Sports Addon",
    "footnote365": "مدعوم من 365Scores"
  },
  "referral": {
    "title": "ادعي أصحابك",
    "intro": "شارك كودك. لما صاحبك يدخل بيه، الاتنين تاخدوا 100 كوين.",
    "yourCode": "كود الدعوة بتاعك",
    "invitedCount": "دعيت {{n}} أصحاب",
    "share": "شارك لينك الدعوة",
    "enterCode": "عندك كود صاحبك؟",
    "codePlaceholder": "اكتب الكود",
    "redeem": "فعّل الكود",
    "redeemed": "تمام! +{{coins}} كوين للاتنين",
    "alreadyRedeemed": "إنت فعّلت كود قبل كده.",
    "shareMessage": "انضم لتشكيلة! دوس على لينك الدعوة بتاعي والاتنين ناخد 100 كوين: {{link}}\n\nمفيش لينك؟ اكتب الكود {{code}} في التطبيق.",
    "signInHint": "سجّل دخولك عشان تجيب كود الدعوة بتاعك."
  },
  "howto": {
    "acca": {
      "title": "كارت اليوم",
      "steps": [
        "اختار نتيجة كل ماتش من ماتشات النهارده.",
        "صيب فيهم كلهم عشان تكسب الكارت.",
        "كل ما السلسلة تطول، تكسب نقاط وكوينز أكتر."
      ]
    },
    "scorePredict": {
      "title": "متوقّع النتيجة",
      "steps": [
        "توقّع النتيجة النهائية لكل ماتش جاي بالظبط.",
        "النتيجة بالظبط = 5 نقاط، النتيجة الصح (فوز/تعادل/خسارة) = نقطتين.",
        "خد كوينز على كل توقّع صح - اصرفها في كل التطبيق."
      ]
    },
    "survivor": {
      "title": "الناجي",
      "steps": [
        "كل جولة اختار منتخب واحد شايف إنه هيكسب.",
        "تنجو لو كسب، وتخرج لو خسر.",
        "مش ممكن تعيد نفس المنتخب. آخر واحد فاضل بيكسب."
      ]
    },
    "challenges": {
      "title": "تحديات يومية",
      "steps": [
        "جاوب على أسئلة الكورة السريعة بتاعة النهارده.",
        "اكسب نقاط وكوينز على كل إجابة صح.",
        "تحديات جديدة كل يوم - حافظ على سلسلتك."
      ]
    },
    "totr": {
      "title": "فريق الجولة",
      "steps": [
        "اختار اللاعبين اللي شايفهم هيتألقوا في الجولة دي.",
        "تاخد +2 نقطة عن كل اختيار يدخل التشكيلة الرسمية، و+5 لو الكابتن بتاعك طلع الأعلى في الجولة.",
        "قارن فريقك بكل الناس في الترتيب."
      ]
    },
    "predictor": {
      "title": "متوقّع الأدوار",
      "steps": [
        "توقّع ترتيب المجموعات وشجرة خروج المغلوب.",
        "اكسب نقاط على كل توقّع صح.",
        "اطلع في الترتيب العالمي."
      ]
    },
    "qualification": {
      "title": "متصدّري المجموعات",
      "steps": [
        "دوس على الفريق اللي شايفه هيتصدّر كل مجموعة.",
        "احفظ توقّعاتك قبل ما المجموعات تخلص.",
        "+12 كوين عن كل متصدّر مجموعة تصيبه."
      ]
    },
    "goldenBoot": {
      "title": "الحذاء الذهبي",
      "steps": [
        "اختار مين شايفه هيكسب الحذاء الذهبي.",
        "تابع سباق الهدّافين لايف.",
        "صيب توقّعك عشان تكسب جوايز كبيرة."
      ]
    },
    "friendLeagues": {
      "title": "دوريات الأصحاب",
      "steps": [
        "اعمل دوري خاص أو ادخل بكود.",
        "نافس أصحابك في كل الألعاب.",
        "اطلع متصدّر الجدول بمجموع نقاطك."
      ]
    },
    "bracketLive": {
      "title": "شجرة الأدوار لايف",
      "steps": [
        "تابع شجرة خروج المغلوب بتتملي لايف.",
        "شوف توقّعك ماشي إزاي.",
        "النقاط بتتثبّت مع كل دور بيتحدّد."
      ]
    },
    "prizeDraw": {
      "title": "السحب على الجوايز",
      "steps": [
        "اصرف الكوينز اللي بتكسبها عشان تشتري تذاكر.",
        "كل تذكرة بتكبّر الجايزة وفرصتك.",
        "سحب أسبوعي - فايز واحد بياخد الجايزة كلها."
      ]
    },
    "store": {
      "title": "متجر الكوينز",
      "steps": [
        "اصرف الكوينز اللي بتكسبها من الألعاب.",
        "افتح إطارات للصورة وبوستات.",
        "جهّز اللي اشتريته من هنا."
      ]
    }
  },
  "prizeDraw": {
    "title": "السحب على الجوايز",
    "intro": "اصرف الكوينز اللي بتكسبها من كل الألعاب على تذاكر. كل تذكرة بتكبّر الجايزة - وكل أسبوع واحد محظوظ بياخدها كلها.",
    "none": "مفيش سحب مفتوح دلوقتي - تعالى تاني قريّب.",
    "pot": "الجايزة",
    "drawsIn": "السحب بعد {{time}}",
    "myTickets": "تذاكري",
    "entrants": "اللاعبين",
    "totalTickets": "إجمالي التذاكر",
    "balance": "كوينزك",
    "buy": "اشتري تذكرة · {{cost}} كوينز",
    "needCoins": "اكسب كوينز أكتر من الألعاب عشان تدخل.",
    "oddsNote": "تذاكر أكتر = فرصة أكبر. الفايز بياخد الجايزة كلها.",
    "signIn": "سجّل دخولك عشان تدخل السحب.",
    "bought": "اتشرت التذكرة - بالتوفيق!",
    "youWonTitle": "🎉 إنت كسبت السحب!",
    "youWonBody": "{{pot}} كوينز اتضافوا لرصيدك.",
    "lastWinner": "آخر فايز",
    "wonPot": "{{name}} كسب {{pot}} كوينز"
  },
  "bracketLive": {
    "title": "شجرة الأدوار لايف",
    "r32": "دور الـ32",
    "r16": "دور الـ16",
    "qf": "ربع النهائي",
    "sf": "نصف النهائي",
    "final": "النهائي",
    "yourChampion": "بطلك المتوقّع",
    "noChampion": "لسه ماخترتش بطل",
    "tally": "{{correct}}/{{decided}} توقّعات صح لحد دلوقتي",
    "preKnockout": "شجرة الأدوار هتشتغل هنا أول ما دور المجموعات يخلص.",
    "noBracketTitle": "لسه مفيش توقّع",
    "noBracketBody": "توقّع شجرة كأس العالم الأول، وبعدين تابعها لايف من هنا.",
    "makeBracket": "اعمل توقّعي"
  },
  "friendLeagues": {
    "title": "دوريات الأصحاب",
    "intro": "مجموعة خاصة بترتيب واحد بيجمع نقاطك من كل الألعاب. اعزم أصحابك بكود، أو ابدأ تحدي 1 ضد 1.",
    "createTitle": "اعمل دوري",
    "namePlaceholder": "اسم الدوري",
    "createLeague": "اعمل دوري",
    "createDuel": "تحدي 1 ضد 1",
    "joinTitle": "ادخل بكود",
    "codePlaceholder": "كود الدعوة",
    "join": "ادخل",
    "mine": "دورياتي",
    "emptyTitle": "لسه مفيش دوريات",
    "emptyBody": "اعمل واحد وشارك الكود، أو ادخل دوري صاحبك بالكود بتاعه.",
    "memberCount": "{{n}} أعضاء",
    "pts": "نقطة",
    "duelTag": "تحدي 1 ضد 1",
    "signInHint": "سجّل دخولك عشان تعمل وتدخل دوريات الأصحاب.",
    "nameRequired": "اكتب اسم الدوري الأول.",
    "codeRequired": "اكتب كود الدعوة.",
    "created": "اتعمل الدوري!",
    "joined": "دخلت {{name}}!",
    "inviteCode": "كود الدعوة",
    "vs": "ضد",
    "standings": "الترتيب",
    "scoreNote": "النتيجة = مجموع نقاطك في الفانتازي والتوقعات والكارت والناجي وتشكيلة الجولة والمتوقّع والتحديات.",
    "emptyBoard": "لسه مفيش أعضاء",
    "leave": "اخرج من الدوري",
    "confirmLeave": "دوس تاني للخروج",
    "shareInvite": "انضم لدوري \"{{name}}\" بتاعي في تشكيلة! الكود: {{code}}",
    "invitePrefilled": "حطّينا الكود - دوس انضمام علشان تدخل."
  },
  "goldenBoot": {
    "title": "الحذاء الذهبي",
    "intro": "اختار مين متوقّع يبقى هدّاف البطولة.",
    "yourPick": "اختيارك",
    "noPick": "مفيش اختيار لسه",
    "pickCta": "اختار",
    "change": "غيّر",
    "pickRank": "{{goals}} أهداف · #{{rank}} في السباق",
    "noGoalsYet": "مسجّلش لسه",
    "race": "الهدّافون لايف",
    "saved": "اتحفظ اختيارك!",
    "share": "توقّع الحذاء الذهبي في تشكيلة ⚽",
    "shareMine": "توقّعي للحذاء الذهبي: {{player}} ⚽ تشكيلة"
  },
  "leaderboardsHub": {
    "title": "الترتيبات",
    "acca": "الكارت",
    "survivor": "الناجي",
    "bracket": "المتوقّع",
    "predictions": "التوقعات",
    "score": "النتايج",
    "fantasy": "الفانتازي",
    "round": "الجولة دي",
    "totr": "تشكيلتك",
    "noDataTitle": "محدش في الترتيب لسه",
    "noDataBody": "كن أول من يلعب وهتظهر هنا."
  },
  "acca": {
    "title": "كارت اليوم",
    "subtitle": "كارت النهاردة: يا كله يا لا",
    "howItWorks": "اختار نتيجة من 3 لـ 6 ماتشات النهاردة. كل اختياراتك لازم تظبط عشان تكسب الجاكبوت.",
    "vs": "ضد",
    "jackpot": "جاكبوت",
    "started": "الماتش بدأ، متقفل",
    "legsPicked": "اختياراتك: {{count}}/6",
    "needThree": "اختار 3 ع الأقل عشان تلعب",
    "allMustHit": "كل الاختيارات لازم تظبط",
    "won": "كله صح! +{{points}} نقطة",
    "lost": "{{hits}}/{{legs}} صح، مفيش جاكبوت النهاردة",
    "daysWon": "{{won}} مكسوب / {{played}} يوم",
    "emptyTitle": "مفيش ماتشات تختار منها",
    "emptyBody": "ارجع لما يتحدد اليوم الجاي من الماتشات."
  },
  "totr": {
    "title": "تشكيلة الجولة",
    "subtitle": "أحسن 11 في الجولة",
    "captainLine": "أعلى نقاط: {{name}}",
    "emptyTitle": "مفيش جولة اتحسبت لسه",
    "emptyBody": "تشكيلة الأحلام بتظهر بعد ما أول جولة تتلعب."
  },
  "totrPredict": {
    "title": "توقّع التشكيلة",
    "howto": "اختار الـ 11 لاعب اللي متوقّع يدخلوا تشكيلة الجولة، وبعدين سمّي الكابتن بتاعك.",
    "locked": "الجولة متقفلة",
    "lockedShort": "متقفلة، النتيجة قربت",
    "liveNow": "مباشر دلوقتي، النقاط بتتحدّث لايف",
    "predictHeader": "توقّع {{round}}",
    "closesAt": "التوقّع بيقفل {{when}}",
    "save": "احفظ التوقّع",
    "saved": "اتحفظ التوقّع! بالتوفيق.",
    "progress": "{{filled}}/11 اتاختاروا",
    "captainHint": "دوس ع شارة اللاعب عشان تخليه كابتن (+5 لو طلع الأعلى في الجولة).",
    "cta": "توقّع تشكيلة الجولة دي",
    "edit": "عدّل توقّعك",
    "yourPrediction": "توقّعك",
    "actualXi": "تشكيلة الجولة الحقيقية",
    "noneTitle": "مفيش توقّع لسه",
    "noneBody": "توقّع التشكيلة قبل الديدلاين عشان تكسب نقاط.",
    "hitsOf": "{{hits}}/11",
    "inXi": "في التشكيلة",
    "captain": "الكابتن",
    "scoringTitle": "النقاط بتتحسب إزاي",
    "scoringRule": "بتاخد +2 نقطة عن كل لاعب اخترته ودخل التشكيلة الحقيقية، وزيادة +5 لو الكابتن بتاعك طلع الأعلى نقاطًا في الجولة.",
    "yourResult": "نتيجتك",
    "yourPoints": "نقاطك",
    "leaderboard": "شوف الترتيب",
    "boardLine": "{{rounds}} جولات · أحسن {{best}}",
    "share": "بتوقّع تشكيلة الجولة في تشكيلة ⚽"
  },
  "rewards": {
    "title": "المكافآت",
    "streak": "أيام متتالية",
    "coins": "كوينز",
    "badges": "أوسمة",
    "claimDaily": "استلم مكافأة اليوم",
    "checkinHint": "افتح التطبيق كل يوم عشان الستريك يكبر وتكسب كوينز أكتر.",
    "comeBackTomorrow": "استلمت النهاردة. ارجع بكرة!",
    "alreadyToday": "استلمت مكافأة النهاردة خلاص.",
    "claimed": "+{{coins}} كوينز! ستريك {{streak}} يوم",
    "storeTitle": "متجر الكوينز",
    "storeHint": "اصرف كوينزك على إطارات بروفايل",
    "watchAdTitle": "اتفرّج واكسب كوينز",
    "watchAdHint": "اتفرّج على إعلان قصير وخد {{coins}} كوينز",
    "adReward": "تمام! +{{coins}} كوينز",
    "adCapReached": "خلصت إعلانات النهارده - تعالى بكره!",
    "adLeft": "فاضل {{n}} النهارده",
    "adRewardsLeft": "فاضل {{n}} مكافآت إعلان النهارده",
    "adBackTomorrow": "ارجع بكره لمزيد",
    "level": {
      "chip": "مستوى {{level}}",
      "xp": "{{into}}/{{total}} XP"
    },
    "prizeWon": "خلّصت #{{rank}} وكسبت {{coins}} كوينز في {{round}}!",
    "streakCalendar": "الستريك بتاعك",
    "freezesLabel": "{{n}} فريز",
    "buyFreeze": "اشتري فريز · {{coins}}",
    "freezeBought": "اتضاف فريز للستريك. يوم غياب واحد علينا.",
    "streakModal": {
      "title": "ستريك يومي",
      "dayN": "اليوم {{day}}",
      "subtitle": "افتح التطبيق كل يوم عشان الستريك يفضل شغّال.",
      "claim": "استلم النهاردة",
      "later": "بعدين"
    },
    "missions": "مهمّات يومية",
    "mission": {
      "open_app": "سجّل دخول النهاردة",
      "make_prediction": "توقّع تشكيلة الجولة",
      "play_challenge": "جاوب على 3 تحديات ماتشات",
      "submit_acca": "اعمل كارت اليوم",
      "survivor_pick": "اعمل اختيار الناجي",
      "spin_today": "استخدم اللفة اليومية",
      "follow_player": "تابع لاعب أو فريق"
    },
    "achievements": "الإنجازات",
    "signInTitle": "سجّل دخول عشان المكافآت",
    "ach": {
      "first_squad": { "title": "مدرّب", "desc": "اعمل فريق فانتازي كأس العالم." },
      "first_captain": { "title": "شارة الكابتن", "desc": "اختار كابتن لفريقك." },
      "first_challenge": { "title": "متحدّي", "desc": "جاوب على تحدي ماتش." },
      "first_prediction": { "title": "عرّاف", "desc": "اعمل توقّع لماتش." },
      "predict_correct": { "title": "توقّعها صح", "desc": "اكسب توقّع ماتش." },
      "first_acca": { "title": "صاحب كارت", "desc": "اعمل أول كارت يومي." },
      "acca_jackpot": { "title": "جاكبوت!", "desc": "اكسب كارت بكل اختياراته صح." },
      "survivor_join": { "title": "ناجي", "desc": "ادخل لعبة آخر واحد صامد." },
      "survivor_run": { "title": "آخر الصامدين", "desc": "انجُ في 3 جولات سرفايفر." },
      "spin_master": { "title": "ملك اللفة", "desc": "استخدم سبن بوست." },
      "follow_five": { "title": "مشجّع متعصّب", "desc": "تابع 5 فرق أو لاعبين." },
      "streak_seven": { "title": "ولّعت", "desc": "اوصل ستريك 7 أيام." },
      "score_first": { "title": "متوقّع نتايج", "desc": "توقّع نتيجة ماتش بالظبط." },
      "score_exact": { "title": "في الصميم", "desc": "صيب نتيجة نهائية بالظبط." },
      "prize_ticket": { "title": "في السحب", "desc": "اشتري تذكرة سحب على الجوايز." },
      "prize_winner": { "title": "كسبت الجايزة", "desc": "اكسب السحب الأسبوعي." },
      "coin_collector": { "title": "جامع الكوينز", "desc": "اوصل لـ 1000 كوينز في رصيدك." },
      "friend_league": { "title": "لمّ الشلّة", "desc": "ادخل أو اعمل دوري أصحاب." }
    }
  },
  "survivor": {
    "title": "الناجي",
    "subtitle": "آخر واحد صامد يكسب",
    "howItWorks": "كل جولة، راهن على منتخب يكسب. التعادل أو الخسارة بتطلّعك برّه، وممنوع تختار نفس المنتخب مرتين.",
    "versus": "ضد {{opponent}} · {{time}}",
    "eliminated": "خرجت في {{round}}",
    "stillAlive": "لسه صامد",
    "notJoined": "اختار منتخب عشان تدخل",
    "roundsSurvived": "نجوت في {{count}} جولة",
    "thisRound": "الجولة دي",
    "locked": "متقفل",
    "yourPick": "اختيارك، دوس على غيره عشان تغيّر",
    "noOptionsTitle": "مفيش ماتش مفتوح تختار منه",
    "noOptionsBody": "ارجع قبل ما الجولة الجاية تبدأ.",
    "history": "رحلتك",
    "stillIn": "لسه صامد",
    "knockedOut": "خرج"
  },
  "club": {
    "title": "مقر النادي",
    "season": "الموسم {{number}}",
    "managerRank": "تصنيف المدير",
    "squadOvr": "تقييم الفريق",
    "chemistry": "الانسجام",
    "budget": "الميزانية",
    "trainingCenter": "مركز التدريب",
    "trainingReady": "حصة تدريب للفريق",
    "trainingHint": "ترفع انسجام الفريق قبل الجولة القادمة.",
    "nextMatch": "المباراة القادمة",
    "transferTarget": "صفقة مقترحة",
    "tactics": "الخطة",
    "highLine": "أسلوب هجومي",
    "noClubTitle": "ناديك يبدأ بتشكيلة",
    "noClubBody": "ابنِ تشكيلة الفانتازي أولًا؛ مقر النادي يعمل بنفس اللاعبين.",
    "noClubCta": "ابنِ تشكيلتي"
  },
  "predictions": {
    "title": "التوقعات",
    "subtitle": "توقّع النتائج واجمع نقاطًا وتصدّر الترتيب",
    "pick": "ترجيح: {{name}}",
    "draw": "تعادل",
    "keyFactorBoth": "العامل الحاسم: فورمة {{home}} {{homeForm}} مقابل {{away}} {{awayForm}}.",
    "keyFactorHome": "العامل الحاسم: فورمة {{home}} الأخيرة {{homeForm}} على أرضه.",
    "keyFactorNone": "العامل الحاسم: مرحلة مبكرة، مؤشّر الفورمة يميل إلى أفضلية الأرض.",
    "noFixturesTitle": "لا مباريات قادمة للتوقع",
    "noFixturesBody": "تظهر التوقعات لمباريات الأيام السبعة القادمة.",
    "myPoints": "نقاطي",
    "yourPick": "توقعك",
    "locked": "مقفول",
    "correct": "صح · +{{points}}",
    "missed": "لم تصب هذه المرة",
    "pointsPerCorrect": "النتيجة الصحيحة = +{{points}} نقاط",
    "leaderboard": "الترتيب",
    "overall": "العام",
    "groups": "الأصدقاء",
    "createGroup": "أنشئ مجموعة",
    "joinGroup": "انضم برمز",
    "groupName": "اسم المجموعة",
    "groupNamePlaceholder": "مثال: دوري الشلة",
    "signInToPlay": "سجّل الدخول لتتوقع وتجمع النقاط",
    "yourPrediction": "توقّعك",
    "tallyCount_zero": "لا توقّعات بعد",
    "tallyCount_one": "توقّع واحد",
    "tallyCount_two": "توقّعان",
    "tallyCount_few": "{{count}} توقّعات",
    "tallyCount_many": "{{count}} توقّعًا",
    "tallyCount_other": "{{count}} توقّع",
    "predictFromMatches": "اتوقّع أي ماتش من شاشته. افتح الماتش واختار النتيجة عشان تكسب نقاط.",
    "topPredictors": "أفضل المتوقّعين",
    "record": "{{correct}} صحيحة من {{played}}",
    "emptyBoardTitle": "لا نقاط على اللوحة بعد",
    "emptyBoardBody": "التوقعات تُحتسب بعد انتهاء مبارياتها. كن الأول!",
    "noGroupsTitle": "لا مجموعات بعد",
    "noGroupsBody": "أنشئ واحدة وادعُ أصدقاءك بالرمز."
  },
  "howTo": {
    "title": "إزاي تلعب",
    "fantasyTitle": "الفانتازي في 60 ثانية",
    "fantasyIntro": "ابنِ تشكيلة من 15 لاعبًا في حدود ميزانية {{budget}} مليون: حارسان و5 مدافعين و5 لاعبي وسط و3 مهاجمين. اختر تشكيلتك الأساسية وقائدًا يحصد ×{{multiplier}} من النقاط ونائبًا يحل محله إذا لم يلعب. التشكيلات تُقفل عند الموعد النهائي لكل جولة، وأي تغيير بعده يُحتسب من الجولة التالية.",
    "pointsTitle": "إزاي اللاعب يجمع نقاط",
    "predictionsTitle": "لعبة التوقعات",
    "predictionsBody": "قبل انطلاق المباراة اختر النتيجة: فوز صاحب الأرض أو تعادل أو فوز الضيف. كل توقع صحيح يمنحك +{{points}} نقاط. تصدّر الترتيب العام، أو أنشئ مجموعة خاصة وادعُ أصدقاءك برمز.",
    "rows": {
      "played60": "اللعب 60 دقيقة أو أكثر",
      "played": "اللعب من 1 إلى 59 دقيقة",
      "goalGK": "هدف من حارس أو مدافع",
      "goalMID": "هدف من لاعب وسط",
      "goalFWD": "هدف من مهاجم",
      "assist": "صناعة هدف",
      "cleanSheetDef": "شباك نظيفة (حارس / مدافع)",
      "cleanSheetMid": "شباك نظيفة (وسط)",
      "saves": "كل {{count}} تصديات (حارس)",
      "penSave": "التصدي لركلة جزاء (حارس)",
      "penMiss": "إضاعة ركلة جزاء",
      "conceded": "كل {{count}} أهداف مستقبَلة (حارس / مدافع)",
      "yellow": "بطاقة صفراء",
      "red": "بطاقة حمراء",
      "ownGoal": "هدف عكسي",
      "bonus": "نقاط أفضل 3 لاعبين في المباراة"
    }
  },
  "matches": {
    "title": "المباريات",
    "noMatchesTitle": "لا مباريات في هذا اليوم",
    "noMatchesBody": "اختر تاريخًا آخر أو تصفّح جدول إحدى البطولات.",
    "liveNow": "بتتلعب دلوقتي",
    "kickoff": "ضربة البداية",
    "round": "الجولة",
    "matchday": "الجولة {{number}}",
    "group": "المجموعة",
    "hot": "مباراة مميّزة",
    "featured": "قمة",
    "featuredMatch": "المباراة المميّزة",
    "yourTeam": "فريقك بيلعب",
    "vs": "ضد",
    "winShort": "فوز",
    "drawShort": "تعادل",
    "homeForm": "فورمة الأرض",
    "awayForm": "فورمة الضيف",
    "modelInsight": "قراءة النموذج",
    "insightStrongHome": "{{team}} مرشح بقوة على أرضه · {{pct}}% وفق نموذج الفورمة.",
    "insightStrongAway": "{{team}} مرشح خارج أرضه · {{pct}}% وفق نموذج الفورمة.",
    "insightTight": "مواجهة متقاربة · النموذج يمنح {{home}} {{homePct}}% مقابل {{away}} {{awayPct}}%.",
    "filterAll": "الكل",
    "filterLive": "مباشر",
    "filterFollowing": "متابعاتي",
    "followingEmptyTitle": "لا مباريات لمتابَعاتك اليوم",
    "followingEmptyBody": "تابِع الفرق والبطولات بزر ★ لتتجمّع مبارياتها هنا.",
    "noLiveTitle": "لا مباريات مباشرة الآن",
    "noLiveBody": "لا شيء يُقام حاليًا. عُد عند انطلاق المباريات.",
    "competitions": "البطولات"
  },
  "favorites": {
    "follow": "تابِع",
    "following": "مُتابَع"
  },
  "following": {
    "title": "متابعاتي",
    "teams": "الفرق",
    "competitions": "البطولات",
    "players": "اللاعيبة",
    "yourTeams": "فرقك",
    "yourCompetitions": "بطولاتك",
    "yourPlayers": "لاعيبتك",
    "suggested": "مقترحين",
    "allCompetitions": "كل البطولات",
    "noPlayersTitle": "مفيش لاعيبة متابَعين",
    "noPlayersBody": "افتح لاعب واضغط النجمة عشان يبان هنا."
  },
  "notifications": {
    "title": "الإشعارات",
    "matchAlerts": "تنبيهات المباريات",
    "fantasy": "الفانتازي",
    "fulltimeAlerts": "نتيجة نهاية المباراة",
    "goalHint": "يوصلك تنبيه لحظة ما يتسجّل هدف.",
    "followedOnlyHint": "بس للمباريات اللي فيها فريق بتتابعه.",
    "fulltimeHint": "النتيجة النهائية لما ماتش فريق متابَع يخلص.",
    "ratingAlerts": "تقييم اللاعبين",
    "ratingHint": "لاعب بتتابعه ياخد تقييمه بعد الماتش.",
    "prematchAlerts": "تذكير قبل الماتش",
    "prematchHint": "تنبيه قبل ما فريق بتتابعه يلعب بساعة تقريبًا.",
    "deadlineHint": "تذكير قبل ميعاد الفانتازي بـ٢٤ ساعة تقريبًا.",
    "widgets": "الويدجتس",
    "widgetMatchTitle": "ويدجتس الشاشة الرئيسية",
    "widgetMatchBody": "النتيجة المباشرة والمسجّل، ترتيب المجموعة، الماتشات، نقاط الفانتازي وحالة السبن، بـ٣ مقاسات.",
    "widgetHowTo": "ضيفهم من الشاشة الرئيسية: اضغط مطوّل على مكان فاضي، اختار Widgets، ودوّر على تشكيلة (الماتش، الفانتازي، السبن). والنتيجة المباشرة بتظهر كمان على شاشة القفل وقت الماتشات.",
    "settingUp": "الإشعارات لسه بتتجهّز وهتبدأ توصلك في تحديث قريب. اختياراتك تحت محفوظة.",
    "testTitle": "⏱️ انتهت المباراة",
    "testBody": "🇲🇦 المغرب 2 - 1 البرازيل 🇧🇷",
    "testTitle2": "ابعت إشعار تجريبي",
    "testHint": "اتأكد إنه بيظهر على شاشتك",
    "testSent": "اتبعت! شوف الإشعارات."
  },
  "notifSettings": {
    "title": "الإشعارات",
    "subtitle": "اختار التنبيهات اللي عايزها. التغييرات بتتحفظ على طول.",
    "sectionMatch": "تنبيهات المباريات",
    "sectionFantasy": "الفانتازي",
    "goalLabel": "تنبيهات الأهداف",
    "goalHint": "يوصلك تنبيه لحظة ما يتسجّل هدف.",
    "followedOnlyLabel": "فرقي بس",
    "followedOnlyHint": "اقصر تنبيهات الأهداف والنتايج على الفرق اللي بتتابعها.",
    "fulltimeLabel": "نتيجة نهاية المباراة",
    "fulltimeHint": "النتيجة النهائية لما ماتش فريق متابَع يخلص.",
    "reminderLabel": "تذكير قبل الماتش",
    "reminderHint": "تنبيه قبل بداية الماتش بساعة تقريبًا.",
    "deadlineLabel": "تذكير المواعيد النهائية",
    "deadlineHint": "تذكير قبل ميعاد الفانتازي بـ٢٤ ساعة تقريبًا.",
    "ratingLabel": "تقييم اللاعبين",
    "ratingHint": "لاعب بتتابعه ياخد تقييمه بعد الماتش.",
    "osDisabledTitle": "الإشعارات مقفولة لتشكيلة",
    "osDisabledBody": "اختياراتك هنا محفوظة، بس موبايلك مش هيعرض تنبيهات لحد ما تفعّل الإشعارات من إعدادات النظام.",
    "osDisabledAction": "افتح الإعدادات",
    "settingUp": "الإشعارات لسه بتتجهّز وهتبدأ توصلك في تحديث قريب. اختياراتك تحت محفوظة.",
    "guestTitle": "سجّل دخولك علشان تظبط التنبيهات",
    "guestBody": "اختياراتك للإشعارات بتتزامن مع حسابك، فسجّل دخولك علشان تتحفظ."
  },
  "more": {
    "title": "المزيد",
    "predictor": "التوقّعات",
    "lineupBuilder": "بنّاء التشكيلة",
    "transferCenter": "مركز الانتقالات",
    "tvSchedules": "مواعيد البث",
    "notifications": "الإشعارات",
    "settings": "الإعدادات",
    "comingSoon": "قريبًا",
    "profile": "حسابك",
    "profileSub": "زامن إعداداتك عبر أجهزتك."
  },
  "predictor": {
    "title": "متوقّع البطولة",
    "groupsTitle": "توقّع المجموعات",
    "groupsHint": "دوس على المنتخبات بترتيب اللي هيتأهلوا بيه (الأول للرابع) في كل مجموعة.",
    "thirdsTitle": "أفضل المراكز الثالثة",
    "thirdsHint": "اختار الـ٨ منتخبات أصحاب المركز الثالث اللي هيتأهلوا لدور الـ٣٢.",
    "reset": "إعادة",
    "nextRound": "التالي",
    "save": "احفظ توقّعاتي",
    "saved": "اتحفظت توقّعاتك",
    "champion": "بطلك المتوقّع",
    "leaderboard": "ترتيب المتوقّعين",
    "points": "النقاط",
    "rank": "الترتيب",
    "emptyBoardTitle": "مفيش توقّعات لسه",
    "emptyBoardBody": "كن أول من يتوقّع البطولة. النقاط بتتحسب مع نزول النتايج.",
    "awaiting": "بيتحدّد من الأدوار السابقة",
    "emptyTitle": "القرعة لسه متعملتش",
    "emptyBody": "متوقّع البطولة بيفتح أول ما مجموعات كأس العالم تتحدّد.",
    "round": {
      "R32": "دور ٣٢",
      "R16": "دور ١٦",
      "QF": "ربع",
      "SF": "نصف",
      "F": "النهائي"
    },
    "legendQualify": "يتأهل",
    "legendThird": "الثالث",
    "legendOut": "خرج",
    "knockoutHint": "اختار الفايزين دور بدور، وبيعدّوا للدور اللي بعده.",
    "random": "🎲 عشوائي",
    "lockTitle": "تأكيد التوقع؟",
    "lockBody": "بعد ما تأكد مش هتقدر تعدّله. توقعك نهائي للترتيب والنقاط والجوايز.",
    "lockConfirm": "أكّد واقفل",
    "championLabel": "بطلك",
    "championCta": "اختار البطل 🏆",
    "rankStat": "ترتيبك {{rank}} · {{points}} نقطة",
    "prizeTitle": "الجوايز",
    "prizeBody": "أحسن ١٠ متوقّعين يكسبوا كوينز."
  },
  "news": {
    "title": "الأخبار",
    "subtitle": "ملخّصات المباريات، بتتكتب أوتوماتيك من البيانات اللحظية.",
    "beat": "{{winner}} فاز على {{loser}} {{score}}.",
    "drew": "{{home}} و{{away}} تعادلا {{score}}.",
    "ownGoal": "عكسي",
    "emptyTitle": "مفيش ملخّصات لسه",
    "emptyBody": "ملخّصات المباريات بتظهر هنا أول ما الماتشات تخلص. تعالى بصّ تاني قريب.",
    "tabHeadlines": "العناوين",
    "tabRecaps": "ملخصات المباريات",
    "tabWorldCup": "كأس العالم",
    "wcTitle": "أخبار كأس العالم",
    "wcEmptyTitle": "مفيش أخبار لكأس العالم لسه",
    "wcEmptyBody": "أخبار البطولة بتنزل هنا أول ما تحصل. تعالى بصّ تاني قريب.",
    "magazine": "تقرير",
    "timeNow": "الآن",
    "time": {
      "minutes": "من {{count}} دقيقة",
      "hours": "من {{count}} ساعة",
      "days": "من {{count}} يوم"
    },
    "headlinesEmptyTitle": "مفيش أخبار لسه",
    "headlinesEmptyBody": "أخبار الكورة بتنزل هنا على مدار اليوم."
  },
  "transfers": {
    "title": "مركز الانتقالات",
    "subtitle": "انتقالات نجوم البطولة، مباشرةً من قاعدة البيانات.",
    "free": "انتقال حر",
    "loan": "إعارة",
    "undisclosed": "غير معلنة",
    "emptyTitle": "مفيش انتقالات لسه",
    "emptyBody": "السوق بيمتلي أول ما الانتقالات تنزل. تعالى بصّ تاني قريب."
  },
  "wcFantasy": {
    "title": "فانتازي كأس العالم",
    "squad": "التشكيلة",
    "budget": "الميزانية",
    "randomizer": "العشوائي",
    "randomizerHint": "لُفّ عشان يطلع منتخب، وبعدها اختار لاعب لمركز فاضي. الحد ٣ من كل منتخب، ولاعب عربي واحد على الأقل.",
    "spin": "لُفّ منتخب",
    "full": "التشكيلة مكتملة",
    "noSlotForNation": "مفيش مركز فاضي للمنتخب ده، لُفّ تاني.",
    "manual": "أو اختر يدويًا",
    "yourSquad": "تشكيلتك",
    "viewPhotos": "اعرض صور اللاعبين",
    "viewFlags": "اعرض أعلام الدول",
    "bench": "احتياطي",
    "teamNamePlaceholder": "اسم فريقك",
    "save": "احفظ التشكيلة",
    "saving": "بيحفظ…",
    "savedToast": "اتحفظت التشكيلة ⚽",
    "saveError": "مش قادر يحفظ، راجع تشكيلتك وحاول تاني.",
    "unavailableTitle": "فانتازي الكأس لسه مش متاح",
    "unavailableBody": "موسم كأس العالم لسه ماتظبطش. تابعنا قريبًا.",
    "issueNeeds": "ناقص {{count}} {{position}}",
    "issueBudget": "زيادة عن الميزانية بـ{{amount}}",
    "issueNation": "كتير من {{nation}} (الحد {{max}})",
    "issueArab": "ضيف {{count}} لاعب من منتخب عربي",
    "issueFormation": "تشكيل غير صالح",
    "issueIncomplete": "التشكيلة ناقصة"
  },
  "privacy": {
    "title": "سياسة الخصوصية",
    "updated": "آخر تحديث ١٦ يونيو ٢٠٢٦",
    "collectTitle": "اللي بنجمعه",
    "collectBody": "لما تسجّل دخول بنخزّن بريدك واسمك الظاهر، ولو دخلت بجوجل أو فيسبوك بنخزّن صورتك. وكمان الفرق والبطولات واللاعيبة اللي بتتابعهم، توقّعاتك، فرق الفانتازي، تفضيل اللغة، و(على الموبايل لو فعّلت) توكن إشعارات. مابنجمعش موقعك ولا جهات اتصالك. وعشان التطبيق يفضل مجاني، بنعرض إعلانات عن طريق Google AdMob اللي بيستخدم معرّف الإعلانات بتاع جهازك.",
    "useTitle": "بنستخدمه إزاي",
    "useBody": "بس لتشغيل التطبيق: حسابك، التخصيص، الترتيب، والإشعارات اللي بتفعّلها. عمرنا مابنبيع بياناتك. الإعلانات بيعرضها Google AdMob، وممكن يستخدم معرّف الإعلانات بتاع جهازك لعرض الإعلانات وقياسها.",
    "providersTitle": "مزوّدو الخدمة",
    "providersBody": "بنستخدم مزوّدي بنية تحتية موثوقين للدخول وقاعدة البيانات، وإشعارات الموبايل، والإعلانات (Google AdMob)، وجوجل/فيسبوك بس لو دخلت بيهم. بيانات الكرة بتيجي من مزوّد خارجي مرخّص؛ ولا بيانة شخصية بتتبعتلهم.",
    "securityTitle": "الأمان",
    "securityBody": "البيانات مشفّرة أثناء النقل (HTTPS)، والوصول للقاعدة محمي بـrow-level security فمحدش يقدر يقرأ أو يعدّل غير حسابه.",
    "deletionTitle": "اختياراتك والحذف",
    "deletionBody": "تقدر تحذف حسابك في أي وقت من البروفايل ← حذف الحساب، وده بيمسح بياناتك نهائيًا. وكمان تتحكم في الإشعارات من البروفايل، أو تراسلنا لطلب الحذف.",
    "childrenTitle": "الأطفال",
    "childrenBody": "تشكيلة مش موجّه للأطفال تحت ١٣ سنة ومابنجمعش بياناتهم عن قصد.",
    "contactTitle": "تواصل",
    "contactBody": "أسئلة؟ راسلنا على"
  },
  "match": {
    "title": "المباراة",
    "events": "الأحداث",
    "lineups": "التشكيلات",
    "ratings": "التقييمات",
    "stats": "الإحصائيات",
    "standings": "الترتيب",
    "news": "أخبار المباراة",
    "trendsTitle": "اتجاهات الفورمة",
    "trendsTeam": "حسب الفريق",
    "trendsGeneral": "عام",
    "noEventsTitle": "لا أحداث بعد",
    "noEventsBody": "ستظهر اللحظات المهمة هنا فور حدوثها.",
    "noLineupsTitle": "التشكيلات غير متاحة",
    "noLineupsBody": "تُنشر التشكيلات عادةً قبل ساعة من انطلاق المباراة.",
    "noRatingsTitle": "التقييمات غير متاحة بعد",
    "noRatingsBody": "تظهر تقييمات اللاعبين فور انطلاق المباراة.",
    "playerOfTheMatch": "رجل المباراة",
    "ratingsHint": "تتحدّث التقييمات لحظيًا مع سير المباراة.",
    "comparison": "أبرز اللاعبين",
    "statGoals": "{{count}} ⚽",
    "statAssists": "{{count}} 🅰",
    "statSaves": "{{count}} 🧤",
    "statMinutes": "{{count}}′",
    "topScorer": "الهدّاف",
    "keyPlayer": "الأخطر",
    "standing": "المجموعة",
    "noStatsTitle": "الإحصائيات غير متاحة",
    "noStatsBody": "هذه البطولة لا توفّر إحصائيات تفصيلية للمباريات.",
    "noStandingsTitle": "لا يوجد جدول ترتيب",
    "noStandingsBody": "الترتيب غير متاح لهذه المرحلة.",
    "h2h": "وجها لوجه",
    "h2hNoHistory": "أول لقاء",
    "h2hHistoryEmpty": "مفيش مواجهات سابقة مسجّلة للفريقين.",
    "h2hWins": "انتصارات",
    "h2hDraws": "تعادلات",
    "h2hRecent": "المواجهات السابقة",
    "h2h365Title": "مواجهات سابقة",
    "h2h365Recent": "أحدث المواجهات",
    "h2h365Form": "آخر المباريات",
    "formWin": "ف",
    "formDraw": "ت",
    "formLoss": "خ",
    "goal": "هدف",
    "ownGoal": "هدف عكسي",
    "penalty": "ركلة جزاء",
    "penaltyMissed": "ركلة جزاء ضائعة",
    "yellowCard": "بطاقة صفراء",
    "redCard": "بطاقة حمراء",
    "substitution": "تبديل",
    "var": "حكم الفيديو",
    "assistBy": "صناعة: {{name}}",
    "possession": "الاستحواذ",
    "xg": "أهداف متوقعة",
    "xgShort": "الأهداف المتوقعة",
    "bigChances": "الفرص الكبيرة",
    "shotmap": "خريطة التسديدات",
    "onTarget": "على المرمى",
    "offTarget": "خارج المرمى",
    "blocked": "مصدودة",
    "sizeIsXg": "حجم النقطة = الأهداف المتوقعة",
    "shotmapHint": "كل نقطة تسديدة موضوعة في مكان تنفيذها. النقاط الأكبر فرص أخطر. الفريق المضيف يهاجم المرمى الأيمن والضيف يهاجم الأيسر.",
    "noShots": "لا توجد تسديدات مسجّلة",
    "xgValue": "{{value}} هدف متوقع",
    "noXgTitle": "الإحصائيات المتقدمة غير متاحة",
    "noXgBody": "تظهر الأهداف المتوقعة وخريطة التسديدات بمجرد مزامنة البيانات التفصيلية لهذه المباراة.",
    "xgPreparing": "تحليلات المباراة بتتجهّز، ارجع بعد شوية.",
    "draw": "تعادل",
    "momentum": "زخم الأهداف المتوقعة",
    "momentumHint": "الأهداف المتوقعة التراكمية · النقاط تمثّل الأهداف",
    "momentumWave": "الزخم",
    "momentumWaveHint": "الضغط الهجومي بمرور الوقت · فوق الخط للفريق المضيف",
    "playerRatings": "تقييمات اللاعبين",
    "starMan": "نجم المباراة",
    "tapForMore": "اضغط على لاعب لعرض المزيد",
    "phaseAll": "المباراة كاملة",
    "phaseFirstHalf": "الشوط الأول",
    "phaseSecondHalf": "الشوط الثاني",
    "groupShots": "التسديدات",
    "groupAttack": "الهجوم",
    "groupPasses": "التمرير",
    "groupDuels": "الالتحامات",
    "groupDefending": "الدفاع",
    "groupGoalkeeping": "حراسة المرمى",
    "statTotalShots": "إجمالي التسديدات",
    "statShotsInsideBox": "تسديدات داخل المنطقة",
    "statShotsOutsideBox": "تسديدات خارج المنطقة",
    "statHitWoodwork": "إصابة القائم",
    "statBlockedShots": "تسديدات محجوبة",
    "statTouchesInBox": "لمسات داخل المنطقة",
    "statFinalThirdEntries": "اختراقات الثلث الأخير",
    "statBigChances": "الفرص الكبيرة",
    "statCrosses": "عرضيات صحيحة",
    "statLongBalls": "كرات طويلة صحيحة",
    "statThrowIns": "الرميات الجانبية",
    "statAccuratePasses": "تمريرات صحيحة",
    "statDuelsWon": "الالتحامات المكسوبة",
    "statAerialDuels": "الكرات الهوائية المكسوبة",
    "statGroundDuels": "الالتحامات الأرضية المكسوبة",
    "statDribbles": "نجاح المراوغات",
    "statDispossessed": "فقدان الكرة",
    "statTackles": "التدخلات",
    "statTacklesWon": "التدخلات الناجحة",
    "statClearances": "الإبعادات",
    "statInterceptions": "الاعتراضات",
    "statRecoveries": "استرجاع الكرات",
    "statSaves": "التصديات",
    "statGoalsPrevented": "الأهداف الممنوعة",
    "ratingXa": "صناعة متوقعة",
    "ratingShots": "تسديدات",
    "ratingKeyPasses": "تمريرات حاسمة",
    "ratingTackles": "تدخلات",
    "ratingDuelsWon": "التحامات مكسوبة",
    "ratingPassAccuracy": "دقة التمرير",
    "ratingInterceptions": "اعتراضات",
    "ratingClearances": "تشتيتات",
    "ratingRecoveries": "استرجاع الكرات",
    "ratingTouches": "لمسات",
    "avgPositions": "متوسط المراكز",
    "avgPositionsHint": "المكان الذي قضى فيه كل لاعب معظم المباراة في المتوسط. الفريق المضيف يهاجم جهة اليمين والضيف جهة اليسار. اضغط على الرقم لعرض الاسم.",
    "shots": "التسديدات",
    "shotsOnTarget": "تسديدات على المرمى",
    "passes": "التمريرات",
    "passesAccurate": "تمريرات صحيحة",
    "passAccuracy": "دقة التمرير",
    "yellowCards": "بطاقات صفراء",
    "redCards": "بطاقات حمراء",
    "fouls": "الأخطاء",
    "corners": "الركنيات",
    "offsides": "التسلل",
    "saves": "التصديات",
    "bench": "البدلاء",
    "coach": "المدرب",
    "absences": "الغيابات",
    "injured": "إصابة",
    "suspended": "إيقاف",
    "formation": "الخطة",
    "halfTime": "الشوط الأول",
    "fullTime": "النهاية",
    "timelineAll": "الكل",
    "timelineKey": "الأبرز",
    "competition": "البطولة",
    "venue": "الملعب",
    "predictionTitle": "توقّع المباراة",
    "modelInsight": "قراءة النموذج",
    "modelBeta": "نموذج الفورمة · تجريبي",
    "modelBasis": "بناءً على الأداء الأخير والنقاط لكل مباراة وفارق الأهداف.",
    "insightFavoured": "النموذج يميل إلى {{team}}.",
    "insightEven": "النتيجة متقاربة، التعادل وارد.",
    "insightStrong": "ترجيح قوي",
    "insightSlight": "ترجيح طفيف",
    "recentForm": "الأداء",
    "ppgShort": "ن/مباراة",
    "kicksOffIn": "يبدأ بعد",
    "unitDays": "يوم",
    "unitHours": "ساعة",
    "unitMins": "دقيقة",
    "unitSecs": "ثانية",
    "live": "مباشر",
    "goalPlacement": "موضع التسديد",
    "viewPitch": "الملعب",
    "viewGoal": "المرمى",
    "noGoalPlacement": "لا توجد تسديدات على المرمى",
    "referee": "الحكم",
    "refGames": "مباريات",
    "refYellowAvg": "صفراء/مباراة",
    "refReds": "حمراء",
    "prediction": "التوقع",
    "predictionModel": "النموذج {{version}}",
    "predictionMostLikely": "النتيجة الأرجح",
    "predictedLineup": "التشكيلة المتوقعة",
    "predictedBadge": "متوقعة",
    "posGoalkeeper": "حراسة المرمى",
    "posDefence": "الدفاع",
    "posMidfield": "الوسط",
    "posAttack": "الهجوم",
    "whereToWatch": "أين تشاهد المباراة",
    "playerDetail": {
      "openProfile": "فتح ملف {{name}}",
      "loading": "جارٍ تحميل الملف",
      "noProfile": "الملف التفصيلي غير متوفر لهذا اللاعب.",
      "season": "الموسم",
      "rating": "التقييم",
      "appearances": "مشاركات",
      "minutes": "الدقائق",
      "conversion": "نسبة التحويل",
      "bigChances": "فرص كبيرة",
      "yearsOld": "{{count}} سنة",
      "cm": "سم",
      "preferredFoot": "القدم",
      "marketValue": "القيمة السوقية",
      "contractUntil": "العقد حتى",
      "heatmap": "خريطة الحرارة",
      "heatmapUnavailable": "خريطة الحرارة غير متوفرة لهذه المباراة"
    },
    "playerStats": {
      "title": "إحصائيات الماتش",
      "rating": "التقييم",
      "starter": "أساسي",
      "derivedNote": "التقييم محسوب من إحصائيات اللاعب في الماتش ده.",
      "fullProfile": "الملف الكامل",
      "minutes": "الدقايق",
      "goals": "الأهداف",
      "assists": "صناعة الأهداف",
      "shots": "التسديدات",
      "passes": "التمريرات",
      "tackles": "الالتحامات",
      "saves": "التصديات",
      "conceded": "أهداف مستقبلة",
      "yellowCards": "كروت صفرا",
      "redCards": "كروت حمرا",
      "penaltySaved": "بلنتيات متصدية",
      "penaltyMissed": "بلنتيات ضايعة",
      "ownGoals": "أهداف عكسية",
      "goalsCount": "{{count}} هدف",
      "assistsCount": "{{count}} أسيست",
      "yellowCard": "كارت أصفر",
      "redCard": "كارت أحمر"
    },
    "matchInfo": {
      "venue": "الملعب",
      "capacity": "السعة {{value}}",
      "builtYear": "بُني {{value}}",
      "weather": "الطقس",
      "degrees": "{{value}}°م",
      "wind": "الرياح {{value}} كم/س",
      "neutralGround": "أرض محايدة",
      "derby": "ديربي",
      "weatherDesc": {
        "clear": "صحو",
        "cloudy": "غائم",
        "partlyCloudy": "غائم جزئيًا",
        "overcast": "ملبد بالغيوم",
        "rain": "ممطر",
        "snow": "ثلوج",
        "thunderstorm": "عواصف رعدية",
        "fog": "ضباب",
        "windy": "رياح"
      }
    }
  },
  "potm": {
    "title": "رجل المباراة",
    "subtitle": "صوّت لأحسن لاعب",
    "subtitleFinal": "مين كان أحسن واحد في الملعب؟",
    "voted": "صوتك اتسجّل",
    "changeHint": "دوس على لاعب تاني عشان تغيّر صوتك",
    "votes": "{{count}} صوت",
    "votesOne": "صوت واحد",
    "votesTwo": "صوتان",
    "votesFew": "{{count}} أصوات",
    "totalVotes": "{{count}} مشجّع صوّتوا",
    "leading": "متقدّم",
    "winner": "رجل مباراة الجماهير",
    "beFirst": "كن أول واحد يصوّت",
    "signIn": "سجّل دخول عشان تصوّت.",
    "showAll": "كل اللاعبين",
    "showLess": "أقل",
    "home": "أصحاب الأرض",
    "away": "الضيوف"
  },
  "compare": {
    "openTitle": "قارن بين اللاعبين",
    "openSubtitle": "ضع أي لاعبين وجهًا لوجه",
    "openLabel": "قارن بين لاعبين وجهًا لوجه",
    "title": "مواجهة مباشرة",
    "collapse": "إخفاء",
    "vs": "ضد",
    "tapHint": "اضغط على لاعب لتبديله. القيمة الأفضل في كل صف مميّزة.",
    "changePlayer": "تغيير اللاعب ({{name}})",
    "pickTitle": "اختر اللاعب {{slot}}",
    "winsCount_zero": "{{n}} إحصائية",
    "winsCount_one": "إحصائية واحدة",
    "winsCount_two": "إحصائيتان",
    "winsCount_few": "{{n}} إحصائيات",
    "winsCount_many": "{{n}} إحصائية",
    "winsCount_other": "{{n}} إحصائية",
    "metricRating": "التقييم",
    "metricMinutes": "الدقائق",
    "metricGoals": "الأهداف",
    "metricAssists": "التمريرات الحاسمة",
    "metricXg": "الأهداف المتوقعة",
    "metricXa": "التمريرات المتوقعة",
    "metricShots": "التسديدات",
    "metricShotsOnTarget": "على المرمى",
    "metricKeyPasses": "تمريرات مفتاحية",
    "metricBigChances": "فرص كبيرة",
    "metricPasses": "التمريرات",
    "metricPassAccuracy": "دقة التمرير"
  },
  "highlights": {
    "title": "فيديوهات"
  },
  "livePitch": {
    "title": "الملعب المباشر",
    "connecting": "جارٍ الاتصال بالبث المباشر…",
    "reconnecting": "جارٍ إعادة الاتصال…",
    "notTracked": "التتبع المباشر غير متاح لهذه المباراة",
    "error": "البث المباشر غير متاح حاليًا",
    "inPossession": "يستحوذ على الكرة",
    "situations": {
      "regular_play": "لعب مفتوح",
      "free_kick": "ركلة حرة",
      "corner_kick": "ركلة ركنية",
      "corner": "ركلة ركنية",
      "goal_kick": "ركلة مرمى",
      "throw_in": "رمية تماس",
      "penalty": "ركلة جزاء",
      "kick_off": "ركلة البداية",
      "goal": "هدف!",
      "safe": "كرة آمنة",
      "attack": "هجمة",
      "dangerous_attack": "هجمة خطيرة",
      "shotoffwoodwork": "على القائم"
    },
    "actions": {
      "goal": "هدف!",
      "shot": "تسديدة",
      "yellow": "بطاقة صفراء",
      "red": "بطاقة حمراء",
      "save": "تصدٍّ",
      "corner": "ركلة ركنية",
      "penalty": "ركلة جزاء",
      "woodwork": "على القائم"
    }
  },
  "liveAlerts": {
    "goalTitle": "⚽ جووول!",
    "redCardTitle": "🟥 طرد",
    "redCardBody": "{{player}}",
    "flashGoal": "هدف!",
    "flashRedCard": "بطاقة حمراء"
  },
  "leagues": {
    "title": "الدوريات",
    "standings": "الترتيب",
    "topScorers": "الهدافون",
    "topAssists": "صناع الأهداف",
    "topAssists": "صنّاع الأهداف",
    "teams": "الفرق",
    "fixtures": "المباريات",
    "pos": "#",
    "team": "الفريق",
    "played": "ل",
    "won": "ف",
    "drawn": "ت",
    "lost": "خ",
    "goalDiff": "+/-",
    "points": "نقاط",
    "form": "آخر النتائج",
    "modeShort": "مختصر",
    "modeFull": "كامل",
    "modeForm": "الفورمة",
    "venue_overall": "الكل",
    "venue_home": "أرضك",
    "venue_away": "برّه",
    "group": "المجموعة {{name}}",
    "zoneQualify": "تأهّل",
    "zoneRelegation": "هبوط",
    "liveStandings": "ترتيب لحظي",
    "bracket": "الأدوار",
    "stageLast64": "دور الـ٦٤",
    "stageLast32": "دور الـ٣٢",
    "stageLast16": "دور الـ١٦",
    "stageQuarter": "ربع النهائي",
    "stageSemi": "نصف النهائي",
    "stageThird": "المركز الثالث",
    "stageFinal": "النهائي",
    "stageRound": "الدور",
    "noBracketTitle": "الأدوار غير متاحة بعد",
    "noBracketBody": "تظهر شجرة الأدوار بعد انتهاء دور المجموعات.",
    "noStandingsTitle": "لا ترتيب بعد",
    "noStandingsBody": "سيظهر الجدول بعد أول مزامنة للبيانات.",
    "noCompetitionsTitle": "لا بطولات بعد",
    "noCompetitionsBody": "تظهر البطولات بعد أول مزامنة للبيانات. راجع README → الإعداد.",
    "fantasyAvailable": "فانتازي متاح",
    "goalsShort": "أهداف",
    "assistsShort": "صناعة",
    "offSeasonTitle": "مفيش ماتشات دلوقتي",
    "offSeasonBody": "الدوري بين موسمين حاليًا. الترتيب الكامل والفرق جاهزين في باقي الأقسام.",
    "offSeasonScorers": "الهدافين هيظهروا أول ما الموسم الجديد يبدأ.",
    "viewStandings": "شوف الترتيب"
  },
  "team": {
    "squad": "القائمة",
    "venue": "الملعب",
    "setFavorite": "اجعله ناديي",
    "unsetFavorite": "إزالة ناديي",
    "favoriteSet": "تم حفظه كفريقك المفضل",
    "noPlayersTitle": "لم تُحمَّل القائمة بعد",
    "noPlayersBody": "تتم مزامنة بيانات اللاعبين تدريجيًا لمراعاة حدود الواجهة المجانية. عُد قريبًا."
  },
  "player": {
    "stats": "إحصائيات الموسم",
    "fantasyPrice": "السعر في فانتازي",
    "fantasyPoints": "نقاط فانتازي",
    "recentForm": "المستوى الأخير",
    "noStatsTitle": "لا إحصائيات بعد",
    "noStatsBody": "تظهر الأرقام التفصيلية بعد مشاركة اللاعب في مباراة مُزامنة.",
    "positions": {
      "GK": "حارس مرمى",
      "DEF": "مدافع",
      "MID": "لاعب وسط",
      "FWD": "مهاجم"
    },
    "positionsShort": {
      "GK": "حارس",
      "DEF": "دفاع",
      "MID": "وسط",
      "FWD": "هجوم"
    },
    "minutes": "الدقائق",
    "goals": "الأهداف",
    "assists": "الصناعة",
    "matchRating": "التقييم",
    "recentMatches": "آخر المباريات",
    "profile365": {
      "title": "ملف اللاعب",
      "via": "عبر 365Scores",
      "yearsOld": "{{count}} سنة",
      "bio": "نبذة",
      "highlights": "الأبرز",
      "career": "إحصائيات المسيرة",
      "recentMatches": "آخر المباريات",
      "transfers": "الانتقالات",
      "current": "الحالي",
      "trophies": "الألقاب"
    }
  },
  "challenges": {
    "title": "التحديات",
    "subtitle": "تحديات الماتشات",
    "howItWorks": "سؤال جديد قبل كل ماتش. جاوب قبل ما الماتش يبدأ وتكسب نقاط زيادة.",
    "vs": "ضد",
    "q": {
      "result": "مين هيكسب؟",
      "overUnder": "أوفر ولا أندر 2.5 جول؟",
      "btts": "الفريقين هيسجلوا؟"
    },
    "opt": {
      "draw": "تعادل",
      "over": "أوفر 2.5",
      "under": "أندر 2.5",
      "yes": "أيوه",
      "no": "لأ"
    },
    "open": "متاح",
    "locked": "مُقفل",
    "resolved": "انتهى",
    "yourPick": "اختيارك",
    "won": "+{{points}} نقطة",
    "missed": "لم تُصِب",
    "voteCount_zero": "لا إجابات بعد",
    "voteCount_one": "إجابة واحدة",
    "voteCount_two": "إجابتان",
    "voteCount_few": "{{count}} إجابات",
    "voteCount_many": "{{count}} إجابة",
    "voteCount_other": "{{count}} إجابة",
    "emptyTitle": "لا تحديات بعد",
    "emptyBody": "تظهر تحديات جديدة كل جولة، تابعنا قريبًا."
  },
  "search": {
    "placeholder": "لاعبون، فرق، بطولات…",
    "players": "اللاعبون",
    "teams": "الفرق",
    "competitions": "البطولات",
    "startTypingTitle": "ابحث عن أي شيء في كرة القدم",
    "startTypingBody": "ابحث عن لاعب أو نادٍ أو بطولة.",
    "noResultsTitle": "لا نتائج لـ «{{query}}»",
    "noResultsBody": "تحقق من الإملاء أو جرّب اسمًا أقصر."
  },
  "auth": {
    "signIn": "تسجيل الدخول",
    "signUp": "إنشاء حساب",
    "signOut": "تسجيل الخروج",
    "continueWithGoogle": "المتابعة بحساب جوجل",
    "continueWithApple": "المتابعة بحساب آبل",
    "continueWithFacebook": "المتابعة بحساب فيسبوك",
    "orWithEmail": "أو بالبريد الإلكتروني",
    "welcomeTitle": "أهلًا بك في تشكيلة",
    "welcomeSubtitle": "نتائج مباشرة وفانتازي وتوقعات - في مكان واحد.",
    "createTitle": "أنشئ حسابك",
    "createSubtitle": "انضم مجانًا لتبني تشكيلة وتتوقّع وتتصدّر لوائح الترتيب.",
    "providerComingSoon": "تسجيل الدخول عبر {{provider}} قريبًا - استخدم جوجل أو البريد حاليًا.",
    "email": "البريد الإلكتروني",
    "password": "كلمة المرور",
    "displayName": "الاسم الظاهر",
    "haveAccount": "لديك حساب بالفعل؟ سجّل الدخول",
    "needAccount": "جديد هنا؟ أنشئ حسابًا",
    "onboardingTitle": "نسمّيك إيه؟",
    "onboardingBody": "اختار الاسم اللي هيظهر في الترتيب وتوقّعاتك. تقدر تغيّره بعدين.",
    "onboardingTeamsTitle": "تابِع فرقك",
    "onboardingTeamsBody": "اختار الأندية والمنتخبات اللي بتحبها. هنجهّزلك مبارياتها عشان تتوقّعها، وتقدر تظبط البطولات واللاعيبة بعدين.",
    "onboardingLeaguesTitle": "تابِع البطولات",
    "onboardingLeaguesBody": "هنعرضلك مبارياتها وترتيبها وأخبارها الأول.",
    "onboardingPlayersTitle": "تابِع اللاعيبة",
    "onboardingPlayersBody": "تابع مستواهم وتقييماتهم وانتقالاتهم.",
    "searchTeams": "ابحث عن فريق",
    "continue": "متابعة",
    "next": "التالي",
    "finish": "تم",
    "settingUp": "بنجهّز حسابك...",
    "verifyEmailTitle": "تفقد بريدك",
    "verifyEmailBody": "أرسلنا رابط تأكيد إلى {{email}}. أكّد بريدك ثم سجّل الدخول.",
    "errors": {
      "invalidEmail": "هذا لا يبدو بريدًا إلكترونيًا صحيحًا.",
      "shortPassword": "يجب أن تكون كلمة المرور 8 أحرف على الأقل.",
      "shortName": "يجب أن يكون الاسم الظاهر حرفين على الأقل.",
      "invalidCredentials": "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
      "emailTaken": "يوجد حساب بهذا البريد الإلكتروني بالفعل.",
      "emailNotConfirmed": "يرجى تأكيد بريدك أولًا - تفقد صندوق الوارد.",
      "generic": "فشل تسجيل الدخول. حاول مجددًا."
    }
  },
  "profile": {
    "title": "حسابي",
    "editProfile": "تعديل الملف",
    "editTitle": "تعديل الملف الشخصي",
    "username": "اسم المستخدم",
    "usernamePlaceholder": "اختر اسمًا فريدًا",
    "usernameChecking": "جارٍ التحقق من التوفّر…",
    "usernameAvailable": "متاح",
    "usernameTaken": "هذا الاسم مستخدَم بالفعل",
    "usernameInvalid": "٣ إلى ٢٠ حرفًا أو رقمًا أو مسافة أو . _ -",
    "avatarSynced": "صورتك تُجلب تلقائيًا من حساب Google / Facebook",
    "savedToast": "تم تحديث الملف",
    "statPoints": "نقاط",
    "statCorrect": "صحيحة",
    "statRank": "الترتيب",
    "settings": "الإعدادات",
    "language": "اللغة",
    "theme": "المظهر",
    "themeDark": "غامق",
    "themeLight": "فاتح",
    "english": "English",
    "arabic": "العربية",
    "numerals": "الأرقام",
    "westernNumerals": "إنجليزية (123)",
    "arabicNumerals": "عربية (١٢٣)",
    "preferences": "التفضيلات",
    "proSection": "Tashkeela Pro",
    "proTitle": "إنت Pro ✨",
    "proActive": "مفعّل، مجانًا فترة التجربة. كل حاجة مفتوحة.",
    "perk": {
      "noAds": "بدون إعلانات",
      "advancedStats": "إحصائيات وتحليلات متقدمة",
      "allGames": "كل الألعاب وأوراق الفانتازي",
      "proBadge": "شارة Pro في البروفايل"
    },
    "notifications": "الإشعارات",
    "widgets": "ويدجتس الشاشة الرئيسية",
    "badges": "الأوسمة",
    "badgesCount": "{{unlocked}}/{{total}}",
    "goalAlerts": "تنبيهات الأهداف",
    "goalsFollowedOnly": "فرقي المتابَعة فقط",
    "deadlineReminders": "تذكير مواعيد الفانتازي",
    "pushHint": "تصل على تطبيق الموبايل. اختياراتك هنا محفوظة وتعمل فور تسجيل دخولك من هاتفك.",
    "game": "دليل اللعب",
    "howToPlay": "إزاي تلعب ونظام النقاط",
    "account": "الحساب",
    "rewards": "المكافآت",
    "referral": "ادعي أصحابك",
    "favoriteTeam": "فريقك المفضل",
    "noFavoriteTeam": "غير محدد",
    "credits": "البيانات والحقوق",
    "deleteAccount": "حذف الحساب",
    "deleteAccountConfirmTitle": "حذف حسابك؟",
    "deleteAccountConfirmBody": "سيؤدي هذا إلى حذف ملفك وتشكيلاتك وعضوياتك في الدوريات نهائيًا. لا يمكن التراجع عن ذلك.",
    "restartForLanguage": "أعد تشغيل التطبيق لتطبيق اتجاه الواجهة الجديد بالكامل.",
    "guestTitle": "أنت تتصفح كزائر",
    "guestBody": "سجّل الدخول لبناء تشكيلة فانتازي والانضمام إلى الدوريات وحفظ تفضيلاتك."
  },
  "credits": {
    "title": "البيانات والحقوق",
    "dataTitle": "بيانات المباريات",
    "dataBody": "النتائج المباشرة والمباريات والترتيب وإحصائيات اللاعبين بتيجي من مزوّدين بيانات رياضية مرخّصين.",
    "ipTitle": "الشعارات والعلامات التجارية",
    "ipBody": "تُعرض شعارات الأندية والبطولات لأغراض التعريف فقط، وتبقى ملكًا لأصحابها من أندية واتحادات، ولا يُقصد بعرضها أي ارتباط أو تأييد.",
    "openSourceTitle": "بُني باستخدام",
    "openSourceBody": "Expo وReact Native وSupabase وNativeWind وTanStack Query وi18next - جميعها مفتوحة المصدر."
  },
  "fantasy": {
    "title": "فانتازي",
    "challengesPopup": {
      "title": "تحديات النهاردة",
      "body": "سؤال سريع قبل كل ماتش. جاوب قبل ما الماتش يبدأ عشان نقط زيادة.",
      "cta": "العب دلوقتي",
      "later": "بعدين"
    },
    "onboarding": {
      "title": "اختر لعبتك",
      "subtitle": "اختر بطولة لتلعب فيها فانتازي. يمكنك الانضمام لمزيد لاحقًا.",
      "teamNameTitle": "سمِّ فريقك",
      "teamNamePlaceholder": "مثال: صقور الصحراء",
      "start": "ابنِ تشكيلتي",
      "noCompetitionsTitle": "لا بطولات فانتازي بعد",
      "noCompetitionsBody": "تُفتح فانتازي للبطولات التي توفر إحصائيات كاملة للاعبين. عُد بعد المزامنة القادمة."
    },
    "builder": {
      "title": "بناء التشكيلة",
      "budget": "الميزانية",
      "remaining": "متبقٍ {{amount}} م",
      "overBudget": "تجاوزت الميزانية بـ {{amount}} م",
      "picked": "{{count}} / {{total}} مُختار",
      "starting": "التشكيلة الأساسية",
      "bench": "البدلاء",
      "captain": "القائد",
      "vice": "نائب القائد",
      "makeCaptain": "تعيين قائدًا",
      "makeVice": "تعيين نائبًا للقائد",
      "moveToStarting": "نقل إلى الأساسية",
      "moveToBench": "نقل إلى البدلاء",
      "remove": "إزالة من التشكيلة",
      "addPlayer": "إضافة لاعب",
      "pickForSlot": "اختر {{position}}",
      "saveSquad": "حفظ التشكيلة",
      "saving": "جارٍ الحفظ…",
      "saved": "تم حفظ التشكيلة",
      "needs": {
        "GK_zero": "اكتمل عدد حراس المرمى",
        "GK_one": "تحتاج إلى حارس مرمى واحد إضافي",
        "GK_two": "تحتاج إلى حارسَي مرمى إضافيين",
        "GK_few": "تحتاج إلى {{count}} حراس مرمى إضافيين",
        "GK_many": "تحتاج إلى {{count}} حارس مرمى إضافيًا",
        "GK_other": "تحتاج إلى {{count}} حارس مرمى إضافي",
        "DEF_zero": "اكتمل عدد المدافعين",
        "DEF_one": "تحتاج إلى مدافع واحد إضافي",
        "DEF_two": "تحتاج إلى مدافعين اثنين إضافيين",
        "DEF_few": "تحتاج إلى {{count}} مدافعين إضافيين",
        "DEF_many": "تحتاج إلى {{count}} مدافعًا إضافيًا",
        "DEF_other": "تحتاج إلى {{count}} مدافع إضافي",
        "MID_zero": "اكتمل عدد لاعبي الوسط",
        "MID_one": "تحتاج إلى لاعب وسط واحد إضافي",
        "MID_two": "تحتاج إلى لاعبَي وسط إضافيين",
        "MID_few": "تحتاج إلى {{count}} لاعبي وسط إضافيين",
        "MID_many": "تحتاج إلى {{count}} لاعب وسط إضافيًا",
        "MID_other": "تحتاج إلى {{count}} لاعب وسط إضافي",
        "FWD_zero": "اكتمل عدد المهاجمين",
        "FWD_one": "تحتاج إلى مهاجم واحد إضافي",
        "FWD_two": "تحتاج إلى مهاجمين اثنين إضافيين",
        "FWD_few": "تحتاج إلى {{count}} مهاجمين إضافيين",
        "FWD_many": "تحتاج إلى {{count}} مهاجمًا إضافيًا",
        "FWD_other": "تحتاج إلى {{count}} مهاجم إضافي"
      },
      "positionFull": "اكتملت خانات {{position}} لديك",
      "alreadyPicked": "موجود في تشكيلتك بالفعل",
      "needCaptain": "اختر قائدًا من تشكيلتك الأساسية",
      "needVice": "اختر نائبًا للقائد من تشكيلتك الأساسية",
      "invalidFormation": "تحتاج الأساسية إلى حارس واحد و3-5 مدافعين و2-5 وسط و1-3 مهاجمين",
      "searchPlayers": "ابحث عن لاعبين…",
      "sortPrice": "السعر",
      "sortName": "الاسم",
      "random": "🎲 تشكيلة عشوائية",
      "randomDone": "تشكيلة عشوائية جاهزة. عدّلها أو احفظها.",
      "randomFailed": "معرفناش نعمل تشكيلة من اللعيبة."
    },
    "myTeam": {
      "title": "فريقي",
      "captainHint": "قائدك يحصد ×{{multiplier}} من النقاط",
      "gwPoints": "نقاط الجولة",
      "totalPoints": "مجموع النقاط",
      "overallRank": "الترتيب العام",
      "viewPhotos": "اعرض صور اللاعبين",
      "viewFlags": "اعرض أعلام الدول",
      "viewClubs": "اعرض شعارات الأندية",
      "provisional": "مؤقتة - تُعتمد بعد انتهاء كل المباريات",
      "noTeamTitle": "لا تشكيلة بعد",
      "noTeamBody": "ابنِ تشكيلتك من 15 لاعبًا وابدأ جمع النقاط هذه الجولة.",
      "noTeamCta": "ابنِ تشكيلتي",
      "editSquad": "تعديل التشكيلة",
      "roundLocked": "الجولة شغالة دلوقتي، فتشكيلتك متقفلة. أي تغيير هتعمله هيتطبق من الجولة اللي بعدها.",
      "pointsBreakdown": "تفاصيل النقاط",
      "noPointsYet": "تظهر النقاط بعد احتساب مباريات هذه الجولة.",
      "breakdown": {
        "minutes": "الدقائق الملعوبة",
        "goals": "أهداف",
        "assists": "صناعة أهداف",
        "clean_sheet": "شباك نظيفة",
        "saves": "تصديات",
        "penalty_saved": "تصدى لركلة جزاء",
        "penalty_missed": "أضاع ركلة جزاء",
        "goals_conceded": "أهداف مستقبَلة",
        "yellow": "بطاقة صفراء",
        "red": "بطاقة حمراء",
        "own_goals": "هدف عكسي",
        "bonus": "نقاط إضافية",
        "captain": "القائد ×{{multiplier}}"
      }
    },
    "gameweek": {
      "title": "الجولة {{number}}",
      "deadline": "الموعد النهائي",
      "deadlinePassed": "انتهى الموعد - التشكيلات مقفلة",
      "countdown": "{{days}} ي {{hours}} س {{minutes}} د",
      "countdownShort": "{{hours}} س {{minutes}} د",
      "transfersNote": "التغييرات بعد الموعد النهائي تُحتسب من الجولة التالية.",
      "yourFixtures": "مباريات لاعبيك",
      "noGameweekTitle": "لا جولة مجدولة",
      "noGameweekBody": "تظهر الجولات بعد مزامنة مباريات هذه البطولة."
    },
    "chips": {
      "title": "الأوراق",
      "hint": "ورقة واحدة لكل جولة، وكل ورقة مرة واحدة في البطولة. تُقفل عند الموعد النهائي.",
      "noTeam": "احفظ تشكيلة أولًا لاستخدام الأوراق.",
      "tripleCaptain": "الكابتن الثلاثي",
      "tripleCaptainDesc": "كابتنك يسجّل ×٣ هذه الجولة.",
      "benchBoost": "دفعة الاحتياطي",
      "benchBoostDesc": "كل الـ١٥ لاعبًا يسجّلون هذه الجولة.",
      "freeHit": "الضربة الحرة",
      "freeHitDesc": "غيّر تشكيلتك للجولة دي بس. بترجع لفريقك القديم الجولة اللي بعدها.",
      "wildcard": "الورقة الحرة",
      "wildcardDesc": "أعد بناء تشكيلتك مجانًا، بدون خصم انتقالات هذه الجولة.",
      "play": "تفعيل",
      "active": "مفعّلة",
      "used": "مستخدمة",
      "soon": "قريبًا",
      "armed": "تم تفعيل {{chip}} لهذه الجولة",
      "removed": "تمت إزالة الورقة"
    },
    "transfers": {
      "title": "الانتقالات",
      "made_zero": "بدون تغييرات · انتقال حر واحد لكل جولة",
      "made_one": "تغيير واحد · انتقال حر واحد لكل جولة",
      "made_two": "تغييران · انتقال حر واحد لكل جولة",
      "made_few": "{{count}} تغييرات · انتقال حر واحد لكل جولة",
      "made_many": "{{count}} تغييرًا · انتقال حر واحد لكل جولة",
      "made_other": "{{count}} تغيير · انتقال حر واحد لكل جولة",
      "free": "حر",
      "chipActive": "انتقالات حرة"
    },
    "leaderboards": {
      "title": "لوائح الترتيب",
      "overall": "العام",
      "miniLeagues": "الدوريات المصغرة",
      "rank": "المركز",
      "teamHeader": "الفريق",
      "pointsHeader": "نقاط",
      "you": "أنت",
      "captainShort": "Ⓒ {{name}}",
      "createLeague": "أنشئ دوريًا مصغرًا",
      "joinLeague": "انضم برمز",
      "leagueName": "اسم الدوري",
      "leagueNamePlaceholder": "مثال: أساطير المكتب",
      "inviteCode": "رمز الدعوة",
      "inviteCodePlaceholder": "رمز من 12 خانة",
      "inviteCodeShare": "شارك هذا الرمز مع أصدقائك: {{code}}",
      "codeCopied": "تم نسخ الرمز",
      "shareInvite": "انضم لدوري \"{{name}}\" بتاعي في تشكيلة! الكود: {{code}}",
      "members_zero": "لا أعضاء",
      "members_one": "عضو واحد",
      "members_two": "عضوان",
      "members_few": "{{count}} أعضاء",
      "members_many": "{{count}} عضوًا",
      "members_other": "{{count}} عضو",
      "leave": "مغادرة الدوري",
      "leaveConfirm": "مغادرة هذا الدوري المصغر؟",
      "emptyOverallTitle": "لا فرق بعد",
      "emptyOverallBody": "كن أول من يبني تشكيلة في هذه البطولة.",
      "noLeaguesTitle": "لا دوريات مصغرة بعد",
      "noLeaguesBody": "أنشئ واحدًا وادعُ أصدقاءك، أو انضم برمز دعوة.",
      "viewSquad": "عرض تشكيلة {{team}}",
      "managedBy": "بقيادة {{manager}}",
      "bench": "الاحتياطي",
      "squadHiddenTitle": "التشكيلة مخفية",
      "squadHiddenBody": "تظهر هذه التشكيلة بعد انتهاء موعد إقفال الجولة."
    },
    "competitions": {
      "worldCup": "كأس العالم ٢٠٢٦",
      "premierLeague": "الدوري الإنجليزي",
      "soon": "قريبًا"
    }
  },
  "errors": {
    "AUTH_REQUIRED": "يرجى تسجيل الدخول أولًا.",
    "RATE_LIMITED": "تمهّل قليلًا - حاول مجددًا بعد دقيقة.",
    "SEASON_NOT_FOUND": "لعبة الفانتازي هذه غير متاحة حاليًا.",
    "INVALID_TEAM_NAME": "يجب أن يكون اسم الفريق بين 3 و30 حرفًا.",
    "INVALID_PICKS": "بيانات تشكيلتك غير صحيحة - حدّث الصفحة وحاول مجددًا.",
    "INVALID_SQUAD_SIZE": "يجب أن تضم تشكيلتك 15 لاعبًا بالضبط.",
    "DUPLICATE_PICKS": "لا يمكن اختيار اللاعب نفسه أكثر من مرة.",
    "INVALID_STARTING_COUNT": "يجب أن تضم الأساسية 11 لاعبًا بالضبط.",
    "INVALID_CAPTAINCY": "اختر قائدًا واحدًا ونائبًا واحدًا من الأساسية.",
    "PLAYER_NOT_IN_COMPETITION": "أحد لاعبيك ليس ضمن هذه البطولة.",
    "INVALID_FORMATION": "خطة الأساسية غير مسموح بها.",
    "BUDGET_EXCEEDED": "هذه التشكيلة تتجاوز الميزانية.",
    "INVALID_LEAGUE_NAME": "يجب أن يكون اسم الدوري بين 3 و30 حرفًا.",
    "NO_FANTASY_TEAM": "ابنِ تشكيلة في هذه البطولة أولًا.",
    "LEAGUE_NOT_FOUND": "لا يوجد دوري بهذا الرمز.",
    "DUEL_FULL": "التحدي ده مكتمل (لاعبين بس).",
    "LEAGUE_FULL": "الدوري ده مكتمل.",
    "NOT_A_MEMBER": "إنت مش عضو في الدوري ده.",
    "INSUFFICIENT_FUNDS": "الكوينز مش كفاية.",
    "DRAW_NOT_FOUND": "السحب ده قفل.",
    "AD_CAP_REACHED": "وصلت حد جوايز الإعلانات النهارده. تعالى بكره!",
    "AD_NOT_COMPLETED": "اتفرّج على الإعلان كامل عشان تكسب كوينز.",
    "TEAM_NOT_FOUND": "تعذّر العثور على هذا الفريق.",
    "INVALID_CHIP": "هذه الورقة غير متاحة.",
    "GAMEWEEK_NOT_FOUND": "تعذّر العثور على هذه الجولة.",
    "DEADLINE_PASSED": "انتهى موعد الإقفال - الأوراق تُقفل عند الموعد.",
    "CHIP_ALREADY_USED": "لقد استخدمت هذه الورقة هذا الموسم.",
    "CHIP_ALREADY_ACTIVE": "لديك ورقة مفعّلة بالفعل لهذه الجولة.",
    "INVALID_PICK": "هذا التوقع غير صالح.",
    "INVALID_STAKE": "اختار قيمة من قيم الرهان.",
    "FIXTURE_NOT_FOUND": "ملقيناش الماتش ده.",
    "PREDICTION_NOT_AVAILABLE": "لسه مفيش احتمالات للماتش ده - ارجع بعدين.",
    "ALREADY_PICKED": "إنت ثبّت توقّعك على الماتش ده قبل كده.",
    "PREDICTION_LOCKED": "الماتش بدأ خلاص.",
    "OAUTH_DISABLED": "تسجيل جوجل غير مفعّل بعد - استخدم البريد حاليًا.",
    "network": "مشكلة في الشبكة - تحقق من اتصالك.",
    "unknown": "حدث خطأ ما. حاول مجددًا.",
    "SPIN_COOLDOWN": "لِفّيت خلاص. ارجع لما العداد يخلص.",
    "GAMEWEEK_LIVE": "في جولة شغالة. تقدر تلِفّ تاني لما تخلص.",
    "INVALID_SPIN_COUNT": "اختار لاعب أو اتنين للبونص.",
    "DUPLICATE_SPIN_PICKS": "اخترت نفس اللاعب مرتين.",
    "SPIN_PICKS_NOT_ONE_NATION": "لازم اختياراتك يكونوا من نفس المنتخب.",
    "REFERRAL_INVALID": "الكود ده مش مظبوط.",
    "REFERRAL_NOT_FOUND": "مفيش حد عنده الكود ده.",
    "REFERRAL_SELF": "مش تقدر تستخدم كودك إنت.",
    "REFERRAL_ALREADY_REDEEMED": "إنت فعّلت كود قبل كده.",
    "NOT_LIVE": "الماتش ده مش شغّال دلوقتي.",
    "ONE_PER_GROUP": "اختار فايز واحد لكل مجموعة.",
    "ALREADY_DOUBLED": "إنت ضاعفت الجايزة دي قبل كده.",
    "NO_REWARD_TO_DOUBLE": "مفيش حاجة تتضاعف هنا لسه.",
    "PREDICTION_NOT_SETTLED": "التوقع ده لسه ماتحسبش.",
    "PREDICTION_NOT_FOUND": "ملقيناش التوقع ده.",
    "FREEZE_MAX": "وصلت لأقصى عدد فريزات.",
    "INVALID_PACK_KIND": "نوع الباكت ده مش متاح.",
    "NO_STICKERS": "الاستيكرز لسه مش جاهزة - تعالى بصّ تاني قريب.",
    "PACK_ALREADY_OPENED": "فتحت باكت النهاردة المجاني خلاص.",
    "ACCA_FULL": "الكارت اتملا (٦ ماتشات بحد أقصى).",
    "FIXTURE_LOCKED": "الماتش بدأ خلاص.",
    "FIXTURE_NOT_IN_COMPETITION": "الماتش ده مش جزء من اللعبة دي.",
    "INVALID_SELECTION": "اختار فوز صاحب الأرض أو تعادل أو فوز الضيف.",
    "NO_OPEN_ROUND": "مفيش جولة مفتوحة دلوقتي.",
    "SURVIVOR_OUT": "خرجت من المسابقة، مفيش اختيار الجولة دي.",
    "TEAM_ALREADY_USED": "استخدمت الفريق ده في جولة فاتت.",
    "TEAM_NOT_PLAYING": "الفريق ده مش لاعب الجولة دي.",
    "CHALLENGE_NOT_FOUND": "التحدّي ده مش متاح.",
    "CHALLENGE_LOCKED": "التحدّي ده اتقفل.",
    "INVALID_OPTION": "اختار إجابة صح.",
    "ITEM_NOT_FOUND": "الحاجة دي مش متاحة.",
    "ITEM_INACTIVE": "الحاجة دي مش متاحة دلوقتي.",
    "ALREADY_OWNED": "ده عندك بالفعل.",
    "NOT_OWNED": "لسه معندكش ده.",
    "GAMEWEEK_LOCKED": "خلصت مهلة الجولة دي.",
    "NEED_ELEVEN": "اختار الـ11 لاعب كلهم.",
    "DUPLICATE_PLAYER": "اخترت نفس اللاعب مرتين.",
    "CAPTAIN_NOT_IN_XI": "الكابتن لازم يكون في الأساسي.",
    "PLAYER_NOT_FOUND": "اللاعب ده مش لاقيينه."
  },
  "competitions": {
    "worldCup": "كأس العالم",
    "championsLeague": "دوري أبطال أوروبا",
    "premierLeague": "الدوري الإنجليزي الممتاز",
    "laLiga": "الدوري الإسباني",
    "serieA": "الدوري الإيطالي",
    "bundesliga": "الدوري الألماني",
    "ligue1": "الدوري الفرنسي"
  },
  "spin": {
    "title": "سبن البونص",
    "cardBody": "لِفّ كل ٢٤ ساعة و هات لاعيبة بونص، نقاط زيادة لو لمعوا.",
    "ready": "جاهز",
    "howItWorks": "لِفّ مرة كل ٢٤ ساعة عشان تطلعلك دولة، واختار لاعب أو اتنين منها. أي لاعب سبن يعمل جولة حلوة (٦ نقاط أو أكتر) بياخدلك ٥٠٪ من نقاطه بونص فوق فريقك.",
    "activeTitle": "البونصات الشغالة",
    "boosted": "بونص",
    "liveNote": "فيه جولة شغالة دلوقتي، فالبونص بتاع اللفة دي هيتحسب من الجولة الجاية.",
    "nextSpinIn": "اللِّفة الجاية بعد",
    "extraSpinAd": "شوف إعلان - لِفّ دلوقتي",
    "buySpin": "اشتري لِفة · {{coins}}",
    "spinning": "بيلِفّ…",
    "spinCta": "لِفّ",
    "choosePrompt": "اختار لحد {{max}} لاعيبة للبونص",
    "reSpin": "لِفّ تاني",
    "confirm": "أكّد البونص",
    "noTeamTitle": "كوّن فريقك الأول",
    "noTeamBody": "اعمل فريق فانتازي كأس العالم عشان تفتح سبن البونص."
  },
  "intro": {
    "headline": "بنغيّر طريقة متابعتك للكورة",
    "subtitle": "نتايج لحظية، فانتازي كأس العالم، توقعات و انتقالات. بيت واحد نيون للعبة الجميلة.",
    "getStarted": "يلا نبدأ",
    "explore": "تصفّح من غير حساب",
    "feature": {
      "live": "نتايج لحظية و مركز الماتشات",
      "fantasy": "فانتازي كأس العالم + سبن البونص",
      "games": "توقّع الأدوار واطلع في الترتيب",
      "transfers": "انتقالات و أخبار فورية"
    }
  }
}
